import Links from '@/shared/constants/navegacao';
import Loading from '@/shared/components/Carregando';
import MyContext from '@/shared/contexts/AppContext';
import RelatoriosUserLabel from '@/modules/reports/presentation/components/RelatoriosUserLabel';
import { AcordoExtrajudicialItem, AtendimentoPresencialItem, AtendimentoRemotoItem, AutorNaturezaItem, DesignacaoEspecialAudienciaItem, DesignacaoEspecialProcessoItem, DiaCalendario, DiaComparecimentoStatus, HonorarioCumprimentoItem, HonorarioSentencaItem, NaturezaAcaoOption, OficioDemaisItem, OficioRequisitorioItem, ProcessoItem, RelatorioCivelFormData, TIPOS_AUDIENCIAS, WIZARD_STEPS, getTipoPeriodoNome, } from './relatorio-civel-page.models';
import { AplicarDecisoesComparecimentoCorregedoria, ComparecimentoDecisaoAcao, } from '@/modules/reports/application/relatorios-corregedoria.service';
import { AutoSaveRelatorio, BuscarDefensorPorCPF, BuscarDefensorPorPessoaId, BuscarDiasComparecimentoAdjacentes, BuscarRelatorioPorId, BuscarTodasLotacoesDefensor, EnviarDiretoCorregedoriaDefensor, ExtrairDefensoriasOpcoes, ObterComarcaVara, ObterTitularidade, SalvarRelatorio, type RelatorioAtividadeDto, } from '@/modules/reports/application/relatorios-atividades.service';
import { AprovarRelatorio, IdentificarDiretoriaRegional, ReprovarRelatorio, } from '@/modules/reports/application/relatorios-aprovacao.service';
import { GetDiretoriaDoUsuario } from '@/modules/structure/diretoria/diretoria.service';
import { Container, Card, Form, Row, Col, Badge, ProgressBar, Nav, Table, Modal, Button } from 'react-bootstrap';
import ModalReprovacao from '@/modules/reports/presentation/components/ModalReprovacao';
import ModalImportarExcelRelatorioCivel from '@/modules/reports/presentation/components/ModalImportarExcelRelatorioCivel';
import { Fragment, useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import { GetPeriodosDoDefensorPorCpf } from '@/modules/business/periodo/periodo.service';
import { ListarOpcoesMovimentacaoTipo } from '@/modules/business/movimentacoes_tipos/movimentacaotipo.service';
import { RELATORIO_CORES } from '../constants/relatorio-cores';
import { ReadDefensorResponseDto, ReadMovimentacaoTipoDto, ReadPeriodoDto, ReadHolidayResponseDto } from '@/api.types';
import { TipoPeriodoDescanso } from '@/modules/business/periodo/enums/tipo-periodo-descanso.enum';
import { apenasLetras, apenasNumeros, formatarData as formatarDataHelper, } from '../components/RelatorioCivelComponents';
import { getTokenPayload } from '@/modules/reports/application/relatorios-atividades.utils';
import { readHoliday } from '@/modules/business/holidays/holiday.service';
import { toast } from 'react-toastify';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useBreadcrumbActions } from '@/shared/contexts/BreadcrumbActionsContext';
import { GetUsuarioBy } from '@/modules/system/usuario/usuario.service';
import { defensorPodeAbrirEditorDoRelatorioAtividade } from '@/modules/reports/presentation/utils/relatorio-defensor-edicao.utils';
import {
  montarItensAutorNaturezaImportados,
  parseAutorNaturezaExcel,
  type LinhaPreviewImportAutorNatureza,
} from '@/modules/reports/presentation/utils/autor-natureza-excel-import.utils';
import {
  montarItensNumeroProcessoImportados,
  parseNumeroProcessoExcel,
  type ExcelImportNumeroAlvo,
  type LinhaPreviewImportNumeroProcesso,
} from '@/modules/reports/presentation/utils/numero-processo-excel-import.utils';
import {
  montarAudienciasPresencialImportadas,
  montarAudienciasRemotaImportadas,
  montarDesignacaoAudienciaImportadas,
  montarDesignacaoProcessoImportadas,
  parseAudienciasPresencialExcel,
  parseAudienciasRemotaExcel,
  parseDesignacaoAudienciaExcel,
  parseDesignacaoProcessoExcel,
  type ExcelImportEtapas81415Alvo,
  type LinhaPreviewAudienciaPresencial,
  type LinhaPreviewAudienciaRemota,
  type LinhaPreviewDesignacaoAudiencia,
  type LinhaPreviewDesignacaoProcesso,
} from '@/modules/reports/presentation/utils/relatorio-civel-etapas-8-14-15-excel-import.utils';

import Step01Comparecimento from './steps/Step01Comparecimento';
import Step02AutorNatureza from './steps/Step02AutorNatureza';
import Step03Contestacao from './steps/Step03Contestacao';
import Step04Reconvecao from './steps/Step04Reconvecao';
import Step05Replica from './steps/Step05Replica';
import Step06Manifestacao from './steps/Step06Manifestacao';
import Step07RazoesFinais from './steps/Step07RazoesFinais';
import Step08Audiencias from './steps/Step08Audiencias';
import Step09Recursos from './steps/Step09Recursos';
import Step10Atendimentos from './steps/Step10Atendimentos';
import Step11AcordosExtrajudiciais from './steps/Step11AcordosExtrajudiciais';
import Step12Honorarios from './steps/Step12Honorarios';
import Step13OficiosExpedidos from './steps/Step13OficiosExpedidos';
import Step14DesignacaoEspecialProcessos from './steps/Step14DesignacaoEspecialProcessos';
import Step15DesignacaoEspecialAudiencias from './steps/Step15DesignacaoEspecialAudiencias';
import Step16OutrosProcedimentos from './steps/Step16OutrosProcedimentos';
import type { QuantidadeLinhasState, RelatorioCivelStepProps } from './steps/relatorio-civel-step-props';
import { useProcessosSections, type ProcessoSection } from './hooks/useProcessosSections';
import { useAutorNatureza } from './hooks/useAutorNatureza';
import { createRenderTabelaProcessosSimples } from './hooks/useListasSimples';
import { useAudiencias } from './hooks/useAudiencias';

// Valores iniciais do formulário
const initialFormData: RelatorioCivelFormData = {
  defensoriaId: 0,
  defensoriaName: '',
  mes: '',
  ano: 0,
  comparecimento: {
    diasComparecimento: 0,
    horasTrabalho: 0,
    audienciasRealizadas: 0,
    audienciasConciliacao: 0,
    audienciasInstrucao: 0,
    despachos: 0,
    diasStatus: [],
  },
  autorNatureza: { itens: [], },
  contestacao: { processos: [], },
  reconvencao: { processos: [], },
  replica: { processos: [], },
  manifestacao: { processos: [], },
  razoesFinais: { processos: [], },
  audiencias: { presenciais: [], remotas: [], },
  recursos: { processos: [], },
  atendimento: { presenciais: [], remotas: [], },
  acordosExtrajudiciais: { itens: [], },
  honorarios: { sentencaAcordao: [], cumprimento: [], },
  oficiosExpedidos: { requisitorios: [], demais: [], },
  designacaoEspecialProcessos: { itens: [], },
  designacaoEspecialAudiencias: { itens: [], },
  outrosProcedimentos: { processos: [], },
};

const STEP_TO_PROCESSO_IMPORT: Partial<Record<number, ProcessoSection>> = {
  3: 'contestacao',
  4: 'reconvencao',
  5: 'replica',
  6: 'manifestacao',
  7: 'razoesFinais',
  9: 'recursos',
  16: 'outrosProcedimentos',
};

function createSetNumerosExistentes(formData: RelatorioCivelFormData, alvo: ExcelImportNumeroAlvo): Set<string> {
  switch (alvo.tipo) {
    case 'processos':
      return new Set(formData[alvo.section].processos.map((p) => p.numeroProcesso.trim()));
    case 'honorarios-sentenca':
      return new Set(formData.honorarios.sentencaAcordao.map((p) => p.numeroProcesso.trim()));
    case 'honorarios-cumprimento':
      return new Set(formData.honorarios.cumprimento.map((p) => p.numeroProcesso.trim()));
    case 'oficios-requisitorios':
      return new Set(formData.oficiosExpedidos.requisitorios.map((p) => p.numeroProcesso.trim()));
    case 'oficios-demais':
      return new Set(formData.oficiosExpedidos.demais.map((p) => p.numeroProcesso.trim()));
  }
}

function tituloModalImportNumero(alvo: ExcelImportNumeroAlvo): string {
  switch (alvo.tipo) {
    case 'processos': {
      const bySection: Record<ProcessoSection, string> = {
        contestacao: 'Contestação',
        reconvencao: 'Reconvenção',
        replica: 'Réplica',
        manifestacao: 'Manifestação nos Autos',
        razoesFinais: 'Razões Finais',
        recursos: 'Recursos',
        outrosProcedimentos: 'Outros Procedimentos',
      };
      return bySection[alvo.section];
    }
    case 'honorarios-sentenca':
      return 'Honorários — Sentença/Acórdão';
    case 'honorarios-cumprimento':
      return 'Honorários — Cumprimento de sentença';
    case 'oficios-requisitorios':
      return 'Ofícios expedidos — Requisitórios';
    case 'oficios-demais':
      return 'Ofícios expedidos — Demais ofícios';
  }
}

type ImportAvancadoState =
  | { open: false }
  | { open: true; variant: 'audiencias-presencial'; linhas: LinhaPreviewAudienciaPresencial[] }
  | { open: true; variant: 'audiencias-remota'; linhas: LinhaPreviewAudienciaRemota[] }
  | { open: true; variant: 'designacao-processo'; linhas: LinhaPreviewDesignacaoProcesso[] }
  | { open: true; variant: 'designacao-audiencia'; linhas: LinhaPreviewDesignacaoAudiencia[] };

export default function RelatorioCivelPage() {
  const context = useContext(MyContext);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { setActions } = useBreadcrumbActions();

  if (!context) {
    throw new Error('RelatorioCivelPage deve ser usado dentro de um MyProvider');
  }

  const { state } = context;

  // Estados
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);
  const [isViewMode, setIsViewMode] = useState(searchParams.get('view') === 'true');
  const origemVisualizacao = searchParams.get('origem') || '';
  const [relatorioId, setRelatorioId] = useState<number | null>(searchParams.get('id') ? parseInt(searchParams.get('id')!) : null);

  /** Corregedoria devolveu ao defensor: envio final é direto à Corregedoria. */
  const [metaReenvioCorregedoria, setMetaReenvioCorregedoria] = useState(false);
  /** Metadados do relatório em modo visualização (Corregedoria decide comparecimento antes do aval final). */
  const [relatorioMetaCorregedoria, setRelatorioMetaCorregedoria] = useState<{ status?: string; corregedoriaAprovadoEm?: string; } | null>(null);
  const [corregedoriaDecisaoDiaLoading, setCorregedoriaDecisaoDiaLoading] = useState<string | null>(null);
  const [defensorData, setDefensorData] = useState<ReadDefensorResponseDto | null>(null);
  const [vara, setVara] = useState('');
  const [titularidade, setTitularidade] = useState('nao-definido');
  const [naturezaAcaoOptions, setNaturezaAcaoOptions] = useState<NaturezaAcaoOption[]>([{ value: '', label: 'Selecione...' }]);
  const [periodosDefensor, setPeriodosDefensor] = useState<ReadPeriodoDto[]>([]);
  const [feriados, setFeriados] = useState<ReadHolidayResponseDto[]>([]);
  /** Comparecimento de relatórios do mês anterior/posterior (somente leitura no calendário). */
  const [diasComparecimentoAdjacentes, setDiasComparecimentoAdjacentes] = useState<DiaComparecimentoStatus[]>([]);
  type DefensoriaOption = { value: number; label: string };
  const [defensoriasOptions, setDefensoriasOptions] = useState<DefensoriaOption[]>([]);

  const getDefensoriaLabel = (id: number | null | undefined) => {
    if (!id)
      return '';

    return defensoriasOptions.find((o) => o.value === id)?.label || '';
  };
  const [showResumoModal, setShowResumoModal] = useState(false);
  const [showEnviarModal, setShowEnviarModal] = useState(false);
  /** Diretoria do usuário logado (fluxo aprovação no editor, modo visualização). */
  const [diretoriaUsuarioId, setDiretoriaUsuarioId] = useState<number | null>(null);
  /** Diretoria regional do relatório (campo da API ao enviar; fallback pela lotação). */
  const [relatorioDiretoriaRegionalId, setRelatorioDiretoriaRegionalId] = useState<number | null>(null);
  /** Defensor vinculado ao CPF do token (para impedir aprovar o próprio relatório). */
  const [defensorLogadoIdView, setDefensorLogadoIdView] = useState<number | null>(null);
  const [showRejectModalDiretoria, setShowRejectModalDiretoria] = useState(false);
  const [aprovingDiretoria, setAprovingDiretoria] = useState(false);
  const [rejectingDiretoria, setRejectingDiretoria] = useState(false);
  const importAutorNaturezaExcelInputRef = useRef<HTMLInputElement>(null);
  const [showImportAutorNaturezaModal, setShowImportAutorNaturezaModal] = useState(false);
  const [importAutorNaturezaLinhas, setImportAutorNaturezaLinhas] = useState<LinhaPreviewImportAutorNatureza[]>([]);
  const importNumeroProcessoExcelInputRef = useRef<HTMLInputElement>(null);
  const pendingNumeroImportAlvoRef = useRef<ExcelImportNumeroAlvo | null>(null);
  const [showImportNumeroProcessoModal, setShowImportNumeroProcessoModal] = useState(false);
  const [importNumeroProcessoLinhas, setImportNumeroProcessoLinhas] = useState<LinhaPreviewImportNumeroProcesso[]>([]);
  const [importNumeroProcessoAlvo, setImportNumeroProcessoAlvo] = useState<ExcelImportNumeroAlvo | null>(null);
  const importAvancadoExcelInputRef = useRef<HTMLInputElement>(null);
  const pendingAvancadoImportRef = useRef<ExcelImportEtapas81415Alvo | null>(null);
  const [importAvancado, setImportAvancado] = useState<ImportAvancadoState>({ open: false });
  const podeEditar = !isViewMode;

  // Dados do formulário
  const [formData, setFormData] = useState<RelatorioCivelFormData>({
    ...initialFormData,
    defensoriaId: parseInt(searchParams.get('defensoriaId') || '0'),
    defensoriaName: searchParams.get('defensoriaName') || '',
    mes: String(searchParams.get('mes') || String(new Date().getMonth() + 1).padStart(2, '0')).padStart(2, '0'),
    ano: parseInt(searchParams.get('ano') || String(new Date().getFullYear())),
  });

  /** Mesma rota `/relatorios/criar` com query diferente não remonta o componente — estado precisa acompanhar a URL. */
  useEffect(() => {
    setIsViewMode(searchParams.get('view') === 'true');
    const idRaw = searchParams.get('id');
    if (idRaw) {
      const parsed = parseInt(idRaw, 10);
      setRelatorioId(Number.isFinite(parsed) ? parsed : null);
    } else {
      setRelatorioId(null);
    }
  }, [searchParams]);

  // Carregar feriados (bloqueios) que afetam a defensoria, para usar no calendário de comparecimento
  useEffect(() => {
    if (!formData.defensoriaId) {
      setFeriados([]);
      return;
    }

    readHoliday({
      skip: 0,
      take: 1000,
      defensoriaId: formData.defensoriaId,
    })
      .then((result) => {
        setFeriados(result[0] || []);
      })
      .catch((error) => {
        console.error('Erro ao carregar feriados para o calendário de comparecimento:', error);
      });
  }, [formData.defensoriaId]);

  // As opções de defensoria devem seguir as mesmas regras do filtro (baseadas nas lotações do defensor),
  // portanto são carregadas junto com os dados do defensor/lotação no fluxo principal.

  // Estados para inputs de número de processo em cada etapa
  const [novoProcessoContestacao, setNovoProcessoContestacao] = useState('');
  const [novoProcessoReconvencao, setNovoProcessoReconvencao] = useState('');
  const [novoProcessoReplica, setNovoProcessoReplica] = useState('');
  const [novoProcessoManifestacao, setNovoProcessoManifestacao] = useState('');
  const [novoProcessoRazoesFinais, setNovoProcessoRazoesFinais] = useState('');
  // Estados para Audiências Presenciais
  const [novaAudienciaPresencial, setNovaAudienciaPresencial] = useState('');
  const [novoNumeroProtocolo, setNovoNumeroProtocolo] = useState('');
  const [novaDataPresencial, setNovaDataPresencial] = useState('');

  // Estados para Audiências Remotas
  const [novaAudienciaRemota, setNovaAudienciaRemota] = useState('');
  const [novoNumeroProcessoRemota, setNovoNumeroProcessoRemota] = useState('');
  const [novaDataRemota, setNovaDataRemota] = useState('');

  // Estados para edição de Audiências Presenciais
  const [editandoAudienciaPresencial, setEditandoAudienciaPresencial] = useState<string | null>(null);
  const [valorEdicaoAudienciaPresencial, setValorEdicaoAudienciaPresencial] = useState('');
  const [valorEdicaoNumeroProtocolo, setValorEdicaoNumeroProtocolo] = useState('');
  const [valorEdicaoDataPresencial, setValorEdicaoDataPresencial] = useState('');

  // Estados para edição de Audiências Remotas
  const [editandoAudienciaRemota, setEditandoAudienciaRemota] = useState<string | null>(null);
  const [valorEdicaoAudienciaRemota, setValorEdicaoAudienciaRemota] = useState('');
  const [valorEdicaoNumeroProcessoRemota, setValorEdicaoNumeroProcessoRemota] = useState('');
  const [valorEdicaoDataRemota, setValorEdicaoDataRemota] = useState('');

  // Estados para edição de Atendimentos Presenciais
  const [editandoAtendimentoPresencial, setEditandoAtendimentoPresencial] = useState<string | null>(null);
  const [valorEdicaoArquivoAtendimentoPresencial, setValorEdicaoArquivoAtendimentoPresencial] = useState<File | null>(null);
  const [valorEdicaoObservacaoAtendimentoPresencial, setValorEdicaoObservacaoAtendimentoPresencial] = useState('');
  const arquivoAtendimentoPresencialEdicaoInputRef = useRef<HTMLInputElement>(null);

  // Estados para edição de Atendimentos Remotos
  const [editandoAtendimentoRemoto, setEditandoAtendimentoRemoto] = useState<string | null>(null);
  const [valorEdicaoArquivoAtendimentoRemoto, setValorEdicaoArquivoAtendimentoRemoto] = useState<File | null>(null);
  const [valorEdicaoObservacaoAtendimentoRemoto, setValorEdicaoObservacaoAtendimentoRemoto] = useState('');
  const arquivoAtendimentoRemotoEdicaoInputRef = useRef<HTMLInputElement>(null);

  const [novoProcessoRecursos, setNovoProcessoRecursos] = useState('');
  // Estados para Atendimentos Presenciais
  const [novoArquivoAtendimentoPresencial, setNovoArquivoAtendimentoPresencial] = useState<File | null>(null);
  const [novaObservacaoAtendimentoPresencial, setNovaObservacaoAtendimentoPresencial] = useState('');
  const arquivoAtendimentoPresencialInputRef = useRef<HTMLInputElement>(null);

  // Estados para Atendimentos Remotos
  const [novoArquivoAtendimentoRemoto, setNovoArquivoAtendimentoRemoto] = useState<File | null>(null);
  const [novaObservacaoAtendimentoRemoto, setNovaObservacaoAtendimentoRemoto] = useState('');
  const arquivoAtendimentoRemotoInputRef = useRef<HTMLInputElement>(null);
  // Estados para Acordos Extrajudiciais
  const [novoNomeParteAcordo, setNovoNomeParteAcordo] = useState('');
  const [novoAnexoAcordo, setNovoAnexoAcordo] = useState<File | null>(null);

  // Estados para Honorários - Sentença/Acórdão
  const [novoProcessoSentencaAcordao, setNovoProcessoSentencaAcordao] = useState('');

  // Estados para Honorários - Cumprimento
  const [novoProcessoCumprimento, setNovoProcessoCumprimento] = useState('');
  // Estados para Ofícios Expedidos - Requisitórios
  const [novoProcessoRequisitorio, setNovoProcessoRequisitorio] = useState('');

  // Estados para Ofícios Expedidos - Demais Ofícios
  const [novoProcessoDemaisOficios, setNovoProcessoDemaisOficios] = useState('');
  // Estados para Designação Especial (Processos)
  const [novoTipoPeca, setNovoTipoPeca] = useState('');
  const [novoNumeroProcessoDesig, setNovoNumeroProcessoDesig] = useState('');
  const [novaDefensoriaId, setNovaDefensoriaId] = useState<number | null>(null);

  // Estados para Designação Especial (Audiências)
  const [novaAudienciaDesig, setNovaAudienciaDesig] = useState('');
  const [novoNumeroProcessoDesigAud, setNovoNumeroProcessoDesigAud] = useState('');
  const [novaDataDesigAud, setNovaDataDesigAud] = useState('');
  const [novaDefensoriaIdDesigAud, setNovaDefensoriaIdDesigAud] = useState<number | null>(null);

  // Estados para edição de Acordos Extrajudiciais
  const [editandoAcordoExtrajudicial, setEditandoAcordoExtrajudicial] = useState<string | null>(null);
  const [valorEdicaoNomeParteAcordo, setValorEdicaoNomeParteAcordo] = useState('');
  const [valorEdicaoAnexoAcordo, setValorEdicaoAnexoAcordo] = useState<File | null>(null);
  const anexoAcordoEdicaoInputRef = useRef<HTMLInputElement>(null);

  // Estados para edição de Honorários - Sentença/Acórdão
  const [editandoHonorarioSentencaAcordao, setEditandoHonorarioSentencaAcordao] = useState<string | null>(null);
  const [valorEdicaoProcessoSentencaAcordao, setValorEdicaoProcessoSentencaAcordao] = useState('');

  // Estados para edição de Honorários - Cumprimento
  const [editandoHonorarioCumprimento, setEditandoHonorarioCumprimento] = useState<string | null>(null);
  const [valorEdicaoProcessoCumprimento, setValorEdicaoProcessoCumprimento] = useState('');

  // Estados para edição de Ofícios Expedidos - Requisitórios
  const [editandoOficioRequisitorio, setEditandoOficioRequisitorio] = useState<string | null>(null);
  const [valorEdicaoProcessoRequisitorio, setValorEdicaoProcessoRequisitorio] = useState('');

  // Estados para edição de Ofícios Expedidos - Demais Ofícios
  const [editandoOficioDemais, setEditandoOficioDemais] = useState<string | null>(null);
  const [valorEdicaoProcessoDemaisOficios, setValorEdicaoProcessoDemaisOficios] = useState('');

  // Estados para edição de Designação Especial (Processos)
  const [editandoDesignacaoEspecialProcesso, setEditandoDesignacaoEspecialProcesso] = useState<string | null>(null);
  const [valorEdicaoTipoPeca, setValorEdicaoTipoPeca] = useState('');
  const [valorEdicaoNumeroProcessoDesig, setValorEdicaoNumeroProcessoDesig] = useState('');
  const [valorEdicaoDefensoriaId, setValorEdicaoDefensoriaId] = useState<number | null>(null);

  // Estados para edição de Designação Especial (Audiências)
  const [editandoDesignacaoEspecialAudiencia, setEditandoDesignacaoEspecialAudiencia] = useState<string | null>(null);
  const [valorEdicaoAudienciaDesig, setValorEdicaoAudienciaDesig] = useState('');
  const [valorEdicaoNumeroProcessoDesigAud, setValorEdicaoNumeroProcessoDesigAud] = useState('');
  const [valorEdicaoDataDesigAud, setValorEdicaoDataDesigAud] = useState('');
  const [valorEdicaoDefensoriaIdDesigAud, setValorEdicaoDefensoriaIdDesigAud] = useState<number | null>(null);

  const [novoProcessoOutros, setNovoProcessoOutros] = useState('');

  // Step 02 (Autor / Natureza)
  const {
    novoAutor,
    setNovoAutor,
    novaNatureza,
    setNovaNatureza,
    quantidadeLinhasAutor,
    setQuantidadeLinhasAutor,
    adicionarAutorNatureza,
    adicionarMultiplasLinhasAutor,
    editandoAutorNatureza,
    confirmandoExclusaoAutor,
    excluirAutorButtonRefs,
    setConfirmandoExclusaoAutor,
    confirmarExclusaoAutor,
    valorEdicaoAutor,
    setValorEdicaoAutor,
    valorEdicaoNatureza,
    setValorEdicaoNatureza,
    iniciarEdicaoAutorNatureza,
    salvarEdicaoAutorNatureza,
    cancelarEdicaoAutorNatureza,
  } = useAutorNatureza({ formData, setFormData, isViewMode });

  // Estados para adicionar múltiplas linhas
  const [quantidadeLinhas, setQuantidadeLinhas] = useState<QuantidadeLinhasState>({
    contestacao: 1,
    reconvencao: 1,
    replica: 1,
    manifestacao: 1,
    razoesFinais: 1,
    recursos: 1,
    outrosProcedimentos: 1,
    acordosExtrajudiciais: 1,
    honorariosSentencaAcordao: 1,
    honorariosCumprimento: 1,
    oficiosRequisitorios: 1,
    oficiosDemais: 1,
    // Sub-etapas
    audienciasPresenciais: 1,
    audienciasRemotas: 1,
    atendimentosPresenciais: 1,
    atendimentosRemotos: 1,
    designacaoEspecialProcessos: 1,
    designacaoEspecialAudiencias: 1,
  });

  // Processos (Steps 03-07/09/16)
  const { adicionarProcesso, adicionarMultiplasLinhas, renderTabelaProcessos } = useProcessosSections({
    formData,
    setFormData,
    quantidadeLinhas,
    apenasNumeros,
    isViewMode,
  });

  const renderTabelaProcessosSimples = createRenderTabelaProcessosSimples({ apenasNumeros, isViewMode });

  const opcoesNaturezaParaImportacao = useMemo(
    () => naturezaAcaoOptions.filter((o) => o.value !== ''),
    [naturezaAcaoOptions],
  );

  const aplicarItensImportadosAutorNatureza = useCallback((itens: AutorNaturezaItem[]) => {
    if (itens.length === 0) return;
    setFormData((prev) => ({
      ...prev,
      autorNatureza: {
        itens: [...prev.autorNatureza.itens, ...itens],
      },
    }));
    toast.success(`${itens.length} linha(s) importada(s) com sucesso.`);
  }, [setFormData]);

  const handleImportAutorNaturezaExcelChange = useCallback(
    async (e: React.ChangeEvent<HTMLInputElement>) => {
      const file = e.target.files?.[0];
      e.target.value = '';
      if (!file || isViewMode) return;
      try {
        const buffer = await file.arrayBuffer();
        const { linhas, erroCabeçalho } = parseAutorNaturezaExcel(buffer, opcoesNaturezaParaImportacao);
        if (erroCabeçalho) {
          toast.error(erroCabeçalho);
          return;
        }
        if (!linhas.length) {
          toast.warning('Nenhuma linha de dados na planilha (após o cabeçalho).');
          return;
        }
        setImportAutorNaturezaLinhas(linhas);
        setShowImportAutorNaturezaModal(true);
      } catch {
        toast.error('Não foi possível ler o arquivo Excel. Use .xlsx ou .xls.');
      }
    },
    [isViewMode, opcoesNaturezaParaImportacao],
  );

  const confirmarImportAutorNaturezaComPreview = useCallback(() => {
    const itens = montarItensAutorNaturezaImportados(importAutorNaturezaLinhas);
    aplicarItensImportadosAutorNatureza(itens);
    const inv = importAutorNaturezaLinhas.filter((l) => !l.valido).length;
    if (inv > 0) {
      toast.info(`${inv} linha(s) com problema foram ignoradas.`);
    }
    setShowImportAutorNaturezaModal(false);
    setImportAutorNaturezaLinhas([]);
  }, [importAutorNaturezaLinhas, aplicarItensImportadosAutorNatureza]);

  const cancelarImportAutorNaturezaModal = useCallback(() => {
    setShowImportAutorNaturezaModal(false);
    setImportAutorNaturezaLinhas([]);
  }, []);

  const solicitarImportNumeroProcessoExcel = useCallback((alvo: ExcelImportNumeroAlvo) => {
    pendingNumeroImportAlvoRef.current = alvo;
    importNumeroProcessoExcelInputRef.current?.click();
  }, []);

  const handleImportNumeroProcessoExcelChange = useCallback(
    async (e: React.ChangeEvent<HTMLInputElement>) => {
      const file = e.target.files?.[0];
      e.target.value = '';
      const alvo = pendingNumeroImportAlvoRef.current;
      pendingNumeroImportAlvoRef.current = null;
      if (!file || isViewMode || !alvo) return;
      try {
        const buffer = await file.arrayBuffer();
        const numerosJaExistentes = createSetNumerosExistentes(formData, alvo);
        const { linhas, erroCabeçalho } = parseNumeroProcessoExcel(buffer, { numerosJaExistentes });
        if (erroCabeçalho) {
          toast.error(erroCabeçalho);
          return;
        }
        if (!linhas.length) {
          toast.warning('Nenhuma linha de dados na planilha (após o cabeçalho).');
          return;
        }
        setImportNumeroProcessoAlvo(alvo);
        setImportNumeroProcessoLinhas(linhas);
        setShowImportNumeroProcessoModal(true);
      } catch {
        toast.error('Não foi possível ler o arquivo Excel. Use .xlsx ou .xls.');
      }
    },
    [isViewMode, formData],
  );

  const confirmarImportNumeroProcessoComPreview = useCallback(() => {
    if (!importNumeroProcessoAlvo) return;
    const alvoSnapshot = importNumeroProcessoAlvo;
    const linhasSnapshot = importNumeroProcessoLinhas;
    const inv = linhasSnapshot.filter((l) => !l.valido).length;
    let adicionados = 0;

    setFormData((prev) => {
      const candidatos = montarItensNumeroProcessoImportados(linhasSnapshot);
      const existentes = createSetNumerosExistentes(prev, alvoSnapshot);
      const novos = candidatos.filter((n) => !existentes.has(n.numeroProcesso.trim()));
      adicionados = novos.length;
      if (novos.length === 0) return prev;

      switch (alvoSnapshot.tipo) {
        case 'processos': {
          const sec = alvoSnapshot.section;
          const ant = prev[sec] as { processos: ProcessoItem[] };
          return {
            ...prev,
            [sec]: { ...ant, processos: [...ant.processos, ...(novos as ProcessoItem[])] },
          };
        }
        case 'honorarios-sentenca':
          return {
            ...prev,
            honorarios: {
              ...prev.honorarios,
              sentencaAcordao: [...prev.honorarios.sentencaAcordao, ...novos],
            },
          };
        case 'honorarios-cumprimento':
          return {
            ...prev,
            honorarios: {
              ...prev.honorarios,
              cumprimento: [...prev.honorarios.cumprimento, ...novos],
            },
          };
        case 'oficios-requisitorios':
          return {
            ...prev,
            oficiosExpedidos: {
              ...prev.oficiosExpedidos,
              requisitorios: [...prev.oficiosExpedidos.requisitorios, ...novos],
            },
          };
        case 'oficios-demais':
          return {
            ...prev,
            oficiosExpedidos: {
              ...prev.oficiosExpedidos,
              demais: [...prev.oficiosExpedidos.demais, ...novos],
            },
          };
      }
    });

    setShowImportNumeroProcessoModal(false);
    setImportNumeroProcessoLinhas([]);
    setImportNumeroProcessoAlvo(null);

    if (adicionados > 0) {
      toast.success(`${adicionados} linha(s) importada(s) com sucesso.`);
      if (inv > 0) {
        toast.info(`${inv} linha(s) com problema foram ignoradas.`);
      }
    } else {
      toast.warning('Nenhuma linha nova foi adicionada (todos os números já constavam na lista ou eram inválidos).');
    }
  }, [importNumeroProcessoAlvo, importNumeroProcessoLinhas]);

  const cancelarImportNumeroProcessoModal = useCallback(() => {
    setShowImportNumeroProcessoModal(false);
    setImportNumeroProcessoLinhas([]);
    setImportNumeroProcessoAlvo(null);
  }, []);

  const solicitarImportAvancadoExcel = useCallback((alvo: ExcelImportEtapas81415Alvo) => {
    pendingAvancadoImportRef.current = alvo;
    importAvancadoExcelInputRef.current?.click();
  }, []);

  const handleImportAvancadoExcelChange = useCallback(
    async (e: React.ChangeEvent<HTMLInputElement>) => {
      const file = e.target.files?.[0];
      e.target.value = '';
      const alvo = pendingAvancadoImportRef.current;
      pendingAvancadoImportRef.current = null;
      if (!file || isViewMode || !alvo) return;

      const precisaDefensorias =
        alvo.tipo === 'designacao-processo' || alvo.tipo === 'designacao-audiencia';
      if (precisaDefensorias && defensoriasOptions.length === 0) {
        toast.warning('Aguarde o carregamento das defensorias ou verifique a lotação antes de importar.');
        return;
      }

      try {
        const buffer = await file.arrayBuffer();
        if (alvo.tipo === 'audiencias-presencial') {
          const { linhas, erroCabeçalho } = parseAudienciasPresencialExcel(buffer, TIPOS_AUDIENCIAS);
          if (erroCabeçalho) {
            toast.error(erroCabeçalho);
            return;
          }
          if (!linhas.length) {
            toast.warning('Nenhuma linha de dados na planilha (após o cabeçalho).');
            return;
          }
          setImportAvancado({ open: true, variant: 'audiencias-presencial', linhas });
          return;
        }
        if (alvo.tipo === 'audiencias-remota') {
          const { linhas, erroCabeçalho } = parseAudienciasRemotaExcel(buffer, TIPOS_AUDIENCIAS);
          if (erroCabeçalho) {
            toast.error(erroCabeçalho);
            return;
          }
          if (!linhas.length) {
            toast.warning('Nenhuma linha de dados na planilha (após o cabeçalho).');
            return;
          }
          setImportAvancado({ open: true, variant: 'audiencias-remota', linhas });
          return;
        }
        if (alvo.tipo === 'designacao-processo') {
          const { linhas, erroCabeçalho } = parseDesignacaoProcessoExcel(buffer, defensoriasOptions);
          if (erroCabeçalho) {
            toast.error(erroCabeçalho);
            return;
          }
          if (!linhas.length) {
            toast.warning('Nenhuma linha de dados na planilha (após o cabeçalho).');
            return;
          }
          setImportAvancado({ open: true, variant: 'designacao-processo', linhas });
          return;
        }
        const { linhas, erroCabeçalho } = parseDesignacaoAudienciaExcel(buffer, defensoriasOptions);
        if (erroCabeçalho) {
          toast.error(erroCabeçalho);
          return;
        }
        if (!linhas.length) {
          toast.warning('Nenhuma linha de dados na planilha (após o cabeçalho).');
          return;
        }
        setImportAvancado({ open: true, variant: 'designacao-audiencia', linhas });
      } catch {
        toast.error('Não foi possível ler o arquivo Excel. Use .xlsx ou .xls.');
      }
    },
    [isViewMode, defensoriasOptions, TIPOS_AUDIENCIAS],
  );

  const confirmarImportAvancadoComPreview = useCallback(() => {
    if (!importAvancado.open) return;
    const snap = importAvancado;
    const inv = snap.linhas.filter((l) => !l.valido).length;
    let adicionados = 0;

    setFormData((prev) => {
      switch (snap.variant) {
        case 'audiencias-presencial': {
          const novos = montarAudienciasPresencialImportadas(snap.linhas);
          adicionados = novos.length;
          if (!novos.length) return prev;
          return {
            ...prev,
            audiencias: {
              ...prev.audiencias,
              presenciais: [...prev.audiencias.presenciais, ...novos],
            },
          };
        }
        case 'audiencias-remota': {
          const novos = montarAudienciasRemotaImportadas(snap.linhas);
          adicionados = novos.length;
          if (!novos.length) return prev;
          return {
            ...prev,
            audiencias: {
              ...prev.audiencias,
              remotas: [...prev.audiencias.remotas, ...novos],
            },
          };
        }
        case 'designacao-processo': {
          const novos = montarDesignacaoProcessoImportadas(
            snap.linhas,
            (id) => defensoriasOptions.find((o) => o.value === id)?.label || '',
          );
          adicionados = novos.length;
          if (!novos.length) return prev;
          return {
            ...prev,
            designacaoEspecialProcessos: {
              ...prev.designacaoEspecialProcessos,
              itens: [...prev.designacaoEspecialProcessos.itens, ...novos],
            },
          };
        }
        case 'designacao-audiencia': {
          const novos = montarDesignacaoAudienciaImportadas(
            snap.linhas,
            (id) => defensoriasOptions.find((o) => o.value === id)?.label || '',
          );
          adicionados = novos.length;
          if (!novos.length) return prev;
          return {
            ...prev,
            designacaoEspecialAudiencias: {
              ...prev.designacaoEspecialAudiencias,
              itens: [...prev.designacaoEspecialAudiencias.itens, ...novos],
            },
          };
        }
      }
    });

    setImportAvancado({ open: false });

    if (adicionados > 0) {
      toast.success(`${adicionados} linha(s) importada(s) com sucesso.`);
      if (inv > 0) {
        toast.info(`${inv} linha(s) com problema foram ignoradas.`);
      }
    } else {
      toast.warning('Nenhuma linha válida para importar.');
    }
  }, [importAvancado, defensoriasOptions]);

  const cancelarImportAvancadoModal = useCallback(() => {
    setImportAvancado({ open: false });
  }, []);

  const {
    adicionarAudienciaPresencial,
    removerAudienciaPresencial,
    adicionarMultiplasLinhasAudienciasPresenciais,
    iniciarEdicaoAudienciaPresencial,
    salvarEdicaoAudienciaPresencial,
    cancelarEdicaoAudienciaPresencial,

    adicionarAudienciaRemota,
    removerAudienciaRemota,
    adicionarMultiplasLinhasAudienciasRemotas,
    iniciarEdicaoAudienciaRemota,
    salvarEdicaoAudienciaRemota,
    cancelarEdicaoAudienciaRemota,
  } = useAudiencias({
    formData,
    setFormData,
    quantidadeLinhas,
    isViewMode,

    novaAudienciaPresencial,
    setNovaAudienciaPresencial,
    novoNumeroProtocolo,
    setNovoNumeroProtocolo,
    novaDataPresencial,
    setNovaDataPresencial,

    novaAudienciaRemota,
    setNovaAudienciaRemota,
    novoNumeroProcessoRemota,
    setNovoNumeroProcessoRemota,
    novaDataRemota,
    setNovaDataRemota,

    editandoAudienciaPresencial,
    setEditandoAudienciaPresencial,
    valorEdicaoAudienciaPresencial,
    setValorEdicaoAudienciaPresencial,
    valorEdicaoNumeroProtocolo,
    setValorEdicaoNumeroProtocolo,
    valorEdicaoDataPresencial,
    setValorEdicaoDataPresencial,

    editandoAudienciaRemota,
    setEditandoAudienciaRemota,
    valorEdicaoAudienciaRemota,
    setValorEdicaoAudienciaRemota,
    valorEdicaoNumeroProcessoRemota,
    setValorEdicaoNumeroProcessoRemota,
    valorEdicaoDataRemota,
    setValorEdicaoDataRemota,
  });

  // Estados para o calendário de comparecimento
  const [justificativaModalDia, setJustificativaModalDia] = useState<number | null>(null);
  const [justificativaTextoTemp, setJustificativaTextoTemp] = useState('');
  const [justificativaArquivoTemp, setJustificativaArquivoTemp] = useState<File | null>(null);
  const justificativaButtonRefs = useRef<{ [key: number]: HTMLElement | null }>({});
  const fileInputRef = useRef<HTMLInputElement>(null);
  const anexoAcordoInputRef = useRef<HTMLInputElement>(null);

  // Funções para Etapa 9 - Atendimentos Presenciais
  const adicionarAtendimentoPresencial = () => {
    if (!novoArquivoAtendimentoPresencial) {
      toast.warning('Selecione um arquivo.');
      return;
    }

    const novoItem: AtendimentoPresencialItem = {
      id: `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
      arquivo: novoArquivoAtendimentoPresencial,
      arquivoNome: novoArquivoAtendimentoPresencial.name,
      observacao: novaObservacaoAtendimentoPresencial.trim(),
    };

    setFormData(prev => ({
      ...prev,
      atendimento: {
        ...prev.atendimento,
        presenciais: [...prev.atendimento.presenciais, novoItem],
      },
    }));

    setNovoArquivoAtendimentoPresencial(null);
    setNovaObservacaoAtendimentoPresencial('');
    if (arquivoAtendimentoPresencialInputRef.current) {
      arquivoAtendimentoPresencialInputRef.current.value = '';
    }
    toast.success('Atendimento presencial adicionado com sucesso!');
  };

  const handleFileChangeAtendimentoPresencial = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      if (file.size > 10 * 1024 * 1024) {
        toast.error('O arquivo deve ter no máximo 10MB.');
        return;
      }
      setNovoArquivoAtendimentoPresencial(file);
    }
  };

  const removerAtendimentoPresencial = (id: string) => {
    setFormData(prev => ({
      ...prev,
      atendimento: {
        ...prev.atendimento,
        presenciais: prev.atendimento.presenciais.filter(item => item.id !== id),
      },
    }));
    toast.success('Atendimento presencial removido com sucesso!');
  };

  const adicionarMultiplasLinhasAtendimentosPresenciais = () => {
    const quantidade = quantidadeLinhas.atendimentosPresenciais;
    if (quantidade < 1) {
      toast.warning('A quantidade mínima é 1.');
      return;
    }

    const novosItens: AtendimentoPresencialItem[] = [];
    for (let i = 0; i < quantidade; i++) {
      novosItens.push({
        id: `${Date.now()}-${Math.random().toString(36).substr(2, 9)}-${i}`,
        arquivo: null,
        observacao: '',
      });
    }

    setFormData(prev => ({
      ...prev,
      atendimento: {
        ...prev.atendimento,
        presenciais: [...prev.atendimento.presenciais, ...novosItens],
      },
    }));

    toast.success(`${quantidade} linha(s) adicionada(s) com sucesso!`);
  };

  // Funções para Etapa 9 - Atendimentos Remotos
  const adicionarAtendimentoRemoto = () => {
    if (!novoArquivoAtendimentoRemoto) {
      toast.warning('Selecione um arquivo.');
      return;
    }

    const novoItem: AtendimentoRemotoItem = {
      id: `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
      arquivo: novoArquivoAtendimentoRemoto,
      arquivoNome: novoArquivoAtendimentoRemoto.name,
      observacao: novaObservacaoAtendimentoRemoto.trim(),
    };

    setFormData(prev => ({
      ...prev,
      atendimento: {
        ...prev.atendimento,
        remotas: [...prev.atendimento.remotas, novoItem],
      },
    }));

    setNovoArquivoAtendimentoRemoto(null);
    setNovaObservacaoAtendimentoRemoto('');
    if (arquivoAtendimentoRemotoInputRef.current) {
      arquivoAtendimentoRemotoInputRef.current.value = '';
    }
    toast.success('Atendimento remoto adicionado com sucesso!');
  };

  const handleFileChangeAtendimentoRemoto = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      if (file.size > 10 * 1024 * 1024) {
        toast.error('O arquivo deve ter no máximo 10MB.');
        return;
      }
      setNovoArquivoAtendimentoRemoto(file);
    }
  };

  const removerAtendimentoRemoto = (id: string) => {
    setFormData(prev => ({
      ...prev,
      atendimento: {
        ...prev.atendimento,
        remotas: prev.atendimento.remotas.filter(item => item.id !== id),
      },
    }));
    toast.success('Atendimento remoto removido com sucesso!');
  };

  const adicionarMultiplasLinhasAtendimentosRemotos = () => {
    const quantidade = quantidadeLinhas.atendimentosRemotos;
    if (quantidade < 1) {
      toast.warning('A quantidade mínima é 1.');
      return;
    }

    const novosItens: AtendimentoRemotoItem[] = [];
    for (let i = 0; i < quantidade; i++) {
      novosItens.push({
        id: `${Date.now()}-${Math.random().toString(36).substr(2, 9)}-${i}`,
        arquivo: null,
        observacao: '',
      });
    }

    setFormData(prev => ({
      ...prev,
      atendimento: {
        ...prev.atendimento,
        remotas: [...prev.atendimento.remotas, ...novosItens],
      },
    }));

    toast.success(`${quantidade} linha(s) adicionada(s) com sucesso!`);
  };

  // Funções para edição de Atendimentos Presenciais
  const iniciarEdicaoAtendimentoPresencial = (item: AtendimentoPresencialItem) => {
    setEditandoAtendimentoPresencial(item.id);
    setValorEdicaoArquivoAtendimentoPresencial(item.arquivo);
    setValorEdicaoObservacaoAtendimentoPresencial(item.observacao);
  };

  const cancelarEdicaoAtendimentoPresencial = () => {
    setEditandoAtendimentoPresencial(null);
    setValorEdicaoArquivoAtendimentoPresencial(null);
    setValorEdicaoObservacaoAtendimentoPresencial('');
    if (arquivoAtendimentoPresencialEdicaoInputRef.current) {
      arquivoAtendimentoPresencialEdicaoInputRef.current.value = '';
    }
  };

  const salvarEdicaoAtendimentoPresencial = (id: string) => {
    if (!valorEdicaoArquivoAtendimentoPresencial && !formData.atendimento.presenciais.find(item => item.id === id)?.arquivo) {
      toast.warning('Selecione um arquivo.');
      return;
    }

    setFormData(prev => ({
      ...prev,
      atendimento: {
        ...prev.atendimento,
        presenciais: prev.atendimento.presenciais.map(item =>
          item.id === id
            ? {
              ...item,
              arquivo: valorEdicaoArquivoAtendimentoPresencial || item.arquivo,
              arquivoNome: valorEdicaoArquivoAtendimentoPresencial ? valorEdicaoArquivoAtendimentoPresencial.name : item.arquivoNome,
              observacao: valorEdicaoObservacaoAtendimentoPresencial.trim(),
            }
            : item
        ),
      },
    }));

    cancelarEdicaoAtendimentoPresencial();
    toast.success('Atendimento presencial atualizado com sucesso!');
  };

  const handleFileChangeAtendimentoPresencialEdicao = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      if (file.size > 10 * 1024 * 1024) {
        toast.error('O arquivo deve ter no máximo 10MB.');
        return;
      }
      setValorEdicaoArquivoAtendimentoPresencial(file);
    }
  };

  // Funções para edição de Atendimentos Remotos
  const iniciarEdicaoAtendimentoRemoto = (item: AtendimentoRemotoItem) => {
    setEditandoAtendimentoRemoto(item.id);
    setValorEdicaoArquivoAtendimentoRemoto(item.arquivo);
    setValorEdicaoObservacaoAtendimentoRemoto(item.observacao);
  };

  const cancelarEdicaoAtendimentoRemoto = () => {
    setEditandoAtendimentoRemoto(null);
    setValorEdicaoArquivoAtendimentoRemoto(null);
    setValorEdicaoObservacaoAtendimentoRemoto('');
    if (arquivoAtendimentoRemotoEdicaoInputRef.current) {
      arquivoAtendimentoRemotoEdicaoInputRef.current.value = '';
    }
  };

  const salvarEdicaoAtendimentoRemoto = (id: string) => {
    if (!valorEdicaoArquivoAtendimentoRemoto && !formData.atendimento.remotas.find(item => item.id === id)?.arquivo) {
      toast.warning('Selecione um arquivo.');
      return;
    }

    setFormData(prev => ({
      ...prev,
      atendimento: {
        ...prev.atendimento,
        remotas: prev.atendimento.remotas.map(item =>
          item.id === id
            ? {
              ...item,
              arquivo: valorEdicaoArquivoAtendimentoRemoto || item.arquivo,
              arquivoNome: valorEdicaoArquivoAtendimentoRemoto ? valorEdicaoArquivoAtendimentoRemoto.name : item.arquivoNome,
              observacao: valorEdicaoObservacaoAtendimentoRemoto.trim(),
            }
            : item
        ),
      },
    }));

    cancelarEdicaoAtendimentoRemoto();
    toast.success('Atendimento remoto atualizado com sucesso!');
  };

  const handleFileChangeAtendimentoRemotoEdicao = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      if (file.size > 10 * 1024 * 1024) {
        toast.error('O arquivo deve ter no máximo 10MB.');
        return;
      }
      setValorEdicaoArquivoAtendimentoRemoto(file);
    }
  };

  // Funções para Etapa 11 - Honorários Sentença/Acórdão
  const adicionarHonorarioSentencaAcordao = () => {
    if (!novoProcessoSentencaAcordao.trim()) {
      toast.warning('Informe o número do processo.');
      return;
    }

    // Verifica se já existe
    if (formData.honorarios.sentencaAcordao.some(p => p.numeroProcesso === novoProcessoSentencaAcordao.trim())) {
      toast.warning('Este processo já foi adicionado.');
      return;
    }

    const novoItem: HonorarioSentencaItem = {
      id: `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
      numeroProcesso: novoProcessoSentencaAcordao.trim(),
      dataAdicao: new Date(),
    };

    setFormData(prev => ({
      ...prev,
      honorarios: {
        ...prev.honorarios,
        sentencaAcordao: [...prev.honorarios.sentencaAcordao, novoItem],
      },
    }));

    setNovoProcessoSentencaAcordao('');
    toast.success('Processo adicionado com sucesso!');
  };

  const removerHonorarioSentencaAcordao = (id: string) => {
    setFormData(prev => ({
      ...prev,
      honorarios: {
        ...prev.honorarios,
        sentencaAcordao: prev.honorarios.sentencaAcordao.filter(item => item.id !== id),
      },
    }));
    toast.success('Processo removido com sucesso!');
  };

  const adicionarMultiplasLinhasHonorariosSentencaAcordao = () => {
    const quantidade = quantidadeLinhas.honorariosSentencaAcordao;
    if (quantidade < 1) {
      toast.warning('A quantidade mínima é 1.');
      return;
    }

    const novosItens: HonorarioSentencaItem[] = [];
    for (let i = 0; i < quantidade; i++) {
      novosItens.push({
        id: `${Date.now()}-${Math.random().toString(36).substr(2, 9)}-${i}`,
        numeroProcesso: '',
        dataAdicao: new Date(),
      });
    }

    setFormData(prev => ({
      ...prev,
      honorarios: {
        ...prev.honorarios,
        sentencaAcordao: [...prev.honorarios.sentencaAcordao, ...novosItens],
      },
    }));

    toast.success(`${quantidade} linha(s) adicionada(s) com sucesso!`);
  };

  // Funções para Etapa 11 - Honorários Cumprimento
  const adicionarHonorarioCumprimento = () => {
    if (!novoProcessoCumprimento.trim()) {
      toast.warning('Informe o número do processo.');
      return;
    }

    // Verifica se já existe
    if (formData.honorarios.cumprimento.some(p => p.numeroProcesso === novoProcessoCumprimento.trim())) {
      toast.warning('Este processo já foi adicionado.');
      return;
    }

    const novoItem: HonorarioCumprimentoItem = {
      id: `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
      numeroProcesso: novoProcessoCumprimento.trim(),
      dataAdicao: new Date(),
    };

    setFormData(prev => ({
      ...prev,
      honorarios: {
        ...prev.honorarios,
        cumprimento: [...prev.honorarios.cumprimento, novoItem],
      },
    }));

    setNovoProcessoCumprimento('');
    toast.success('Processo adicionado com sucesso!');
  };

  const removerHonorarioCumprimento = (id: string) => {
    setFormData(prev => ({
      ...prev,
      honorarios: {
        ...prev.honorarios,
        cumprimento: prev.honorarios.cumprimento.filter(item => item.id !== id),
      },
    }));
    toast.success('Processo removido com sucesso!');
  };

  const adicionarMultiplasLinhasHonorariosCumprimento = () => {
    const quantidade = quantidadeLinhas.honorariosCumprimento;
    if (quantidade < 1) {
      toast.warning('A quantidade mínima é 1.');
      return;
    }

    const novosItens: HonorarioCumprimentoItem[] = [];
    for (let i = 0; i < quantidade; i++) {
      novosItens.push({
        id: `${Date.now()}-${Math.random().toString(36).substr(2, 9)}-${i}`,
        numeroProcesso: '',
        dataAdicao: new Date(),
      });
    }

    setFormData(prev => ({
      ...prev,
      honorarios: {
        ...prev.honorarios,
        cumprimento: [...prev.honorarios.cumprimento, ...novosItens],
      },
    }));

    toast.success(`${quantidade} linha(s) adicionada(s) com sucesso!`);
  };

  // Funções para Etapa 12 - Ofícios Requisitórios
  const adicionarOficioRequisitorio = () => {
    if (!novoProcessoRequisitorio.trim()) {
      toast.warning('Informe o número do processo.');
      return;
    }

    // Verifica se já existe
    if (formData.oficiosExpedidos.requisitorios.some(p => p.numeroProcesso === novoProcessoRequisitorio.trim())) {
      toast.warning('Este processo já foi adicionado.');
      return;
    }

    const novoItem: OficioRequisitorioItem = {
      id: `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
      numeroProcesso: novoProcessoRequisitorio.trim(),
      dataAdicao: new Date(),
    };

    setFormData(prev => ({
      ...prev,
      oficiosExpedidos: {
        ...prev.oficiosExpedidos,
        requisitorios: [...prev.oficiosExpedidos.requisitorios, novoItem],
      },
    }));

    setNovoProcessoRequisitorio('');
    toast.success('Processo adicionado com sucesso!');
  };

  const removerOficioRequisitorio = (id: string) => {
    setFormData(prev => ({
      ...prev,
      oficiosExpedidos: {
        ...prev.oficiosExpedidos,
        requisitorios: prev.oficiosExpedidos.requisitorios.filter(item => item.id !== id),
      },
    }));
    toast.success('Processo removido com sucesso!');
  };

  const adicionarMultiplasLinhasOficiosRequisitorios = () => {
    const quantidade = quantidadeLinhas.oficiosRequisitorios;
    if (quantidade < 1) {
      toast.warning('A quantidade mínima é 1.');
      return;
    }

    const novosItens: OficioRequisitorioItem[] = [];
    for (let i = 0; i < quantidade; i++) {
      novosItens.push({
        id: `${Date.now()}-${Math.random().toString(36).substr(2, 9)}-${i}`,
        numeroProcesso: '',
        dataAdicao: new Date(),
      });
    }

    setFormData(prev => ({
      ...prev,
      oficiosExpedidos: {
        ...prev.oficiosExpedidos,
        requisitorios: [...prev.oficiosExpedidos.requisitorios, ...novosItens],
      },
    }));

    toast.success(`${quantidade} linha(s) adicionada(s) com sucesso!`);
  };

  // Funções para Etapa 12 - Demais Ofícios
  const adicionarOficioDemais = () => {
    if (!novoProcessoDemaisOficios.trim()) {
      toast.warning('Informe o número do processo.');
      return;
    }

    // Verifica se já existe
    if (formData.oficiosExpedidos.demais.some(p => p.numeroProcesso === novoProcessoDemaisOficios.trim())) {
      toast.warning('Este processo já foi adicionado.');
      return;
    }

    const novoItem: OficioDemaisItem = {
      id: `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
      numeroProcesso: novoProcessoDemaisOficios.trim(),
      dataAdicao: new Date(),
    };

    setFormData(prev => ({
      ...prev,
      oficiosExpedidos: {
        ...prev.oficiosExpedidos,
        demais: [...prev.oficiosExpedidos.demais, novoItem],
      },
    }));

    setNovoProcessoDemaisOficios('');
    toast.success('Processo adicionado com sucesso!');
  };

  const removerOficioDemais = (id: string) => {
    setFormData(prev => ({
      ...prev,
      oficiosExpedidos: {
        ...prev.oficiosExpedidos,
        demais: prev.oficiosExpedidos.demais.filter(item => item.id !== id),
      },
    }));
    toast.success('Processo removido com sucesso!');
  };

  const adicionarMultiplasLinhasOficiosDemais = () => {
    const quantidade = quantidadeLinhas.oficiosDemais;
    if (quantidade < 1) {
      toast.warning('A quantidade mínima é 1.');
      return;
    }

    const novosItens: OficioDemaisItem[] = [];
    for (let i = 0; i < quantidade; i++) {
      novosItens.push({
        id: `${Date.now()}-${Math.random().toString(36).substr(2, 9)}-${i}`,
        numeroProcesso: '',
        dataAdicao: new Date(),
      });
    }

    setFormData(prev => ({
      ...prev,
      oficiosExpedidos: {
        ...prev.oficiosExpedidos,
        demais: [...prev.oficiosExpedidos.demais, ...novosItens],
      },
    }));

    toast.success(`${quantidade} linha(s) adicionada(s) com sucesso!`);
  };

  // Funções para edição de Acordos Extrajudiciais
  const iniciarEdicaoAcordoExtrajudicial = (item: AcordoExtrajudicialItem) => {
    setEditandoAcordoExtrajudicial(item.id);
    setValorEdicaoNomeParteAcordo(item.nomeParte);
    setValorEdicaoAnexoAcordo(item.anexo);
  };

  const cancelarEdicaoAcordoExtrajudicial = () => {
    setEditandoAcordoExtrajudicial(null);
    setValorEdicaoNomeParteAcordo('');
    setValorEdicaoAnexoAcordo(null);
  };

  const salvarEdicaoAcordoExtrajudicial = (id: string) => {
    if (!valorEdicaoNomeParteAcordo.trim()) {
      toast.warning('Informe o nome da parte.');
      return;
    }

    setFormData(prev => ({
      ...prev,
      acordosExtrajudiciais: {
        ...prev.acordosExtrajudiciais,
        itens: prev.acordosExtrajudiciais.itens.map(item =>
          item.id === id
            ? {
              ...item,
              nomeParte: apenasLetras(valorEdicaoNomeParteAcordo.trim()),
              anexo: valorEdicaoAnexoAcordo,
              anexoNome: valorEdicaoAnexoAcordo ? valorEdicaoAnexoAcordo.name : item.anexoNome,
            }
            : item
        ),
      },
    }));

    cancelarEdicaoAcordoExtrajudicial();
    toast.success('Acordo extrajudicial atualizado com sucesso!');
  };

  const handleFileChangeAcordoEdicao = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      if (file.size > 10 * 1024 * 1024) {
        toast.error('O arquivo deve ter no máximo 10MB.');
        return;
      }
      setValorEdicaoAnexoAcordo(file);
    }
  };

  // Funções para edição de Honorários - Sentença/Acórdão
  const iniciarEdicaoHonorarioSentencaAcordao = (item: HonorarioSentencaItem) => {
    setEditandoHonorarioSentencaAcordao(item.id);
    setValorEdicaoProcessoSentencaAcordao(item.numeroProcesso);
  };

  const cancelarEdicaoHonorarioSentencaAcordao = () => {
    setEditandoHonorarioSentencaAcordao(null);
    setValorEdicaoProcessoSentencaAcordao('');
  };

  const salvarEdicaoHonorarioSentencaAcordao = (id: string) => {
    if (!valorEdicaoProcessoSentencaAcordao.trim()) {
      toast.warning('Informe o número do processo.');
      return;
    }

    setFormData(prev => ({
      ...prev,
      honorarios: {
        ...prev.honorarios,
        sentencaAcordao: prev.honorarios.sentencaAcordao.map(item =>
          item.id === id
            ? { ...item, numeroProcesso: valorEdicaoProcessoSentencaAcordao.trim() }
            : item
        ),
      },
    }));

    cancelarEdicaoHonorarioSentencaAcordao();
    toast.success('Honorário atualizado com sucesso!');
  };

  // Funções para edição de Honorários - Cumprimento
  const iniciarEdicaoHonorarioCumprimento = (item: HonorarioCumprimentoItem) => {
    setEditandoHonorarioCumprimento(item.id);
    setValorEdicaoProcessoCumprimento(item.numeroProcesso);
  };

  const cancelarEdicaoHonorarioCumprimento = () => {
    setEditandoHonorarioCumprimento(null);
    setValorEdicaoProcessoCumprimento('');
  };

  const salvarEdicaoHonorarioCumprimento = (id: string) => {
    if (!valorEdicaoProcessoCumprimento.trim()) {
      toast.warning('Informe o número do processo.');
      return;
    }

    setFormData(prev => ({
      ...prev,
      honorarios: {
        ...prev.honorarios,
        cumprimento: prev.honorarios.cumprimento.map(item =>
          item.id === id
            ? { ...item, numeroProcesso: valorEdicaoProcessoCumprimento.trim() }
            : item
        ),
      },
    }));

    cancelarEdicaoHonorarioCumprimento();
    toast.success('Honorário atualizado com sucesso!');
  };

  // Funções para edição de Ofícios Expedidos - Requisitórios
  const iniciarEdicaoOficioRequisitorio = (item: OficioRequisitorioItem) => {
    setEditandoOficioRequisitorio(item.id);
    setValorEdicaoProcessoRequisitorio(item.numeroProcesso);
  };

  const cancelarEdicaoOficioRequisitorio = () => {
    setEditandoOficioRequisitorio(null);
    setValorEdicaoProcessoRequisitorio('');
  };

  const salvarEdicaoOficioRequisitorio = (id: string) => {
    if (!valorEdicaoProcessoRequisitorio.trim()) {
      toast.warning('Informe o número do processo.');
      return;
    }

    setFormData(prev => ({
      ...prev,
      oficiosExpedidos: {
        ...prev.oficiosExpedidos,
        requisitorios: prev.oficiosExpedidos.requisitorios.map(item =>
          item.id === id
            ? { ...item, numeroProcesso: valorEdicaoProcessoRequisitorio.trim() }
            : item
        ),
      },
    }));

    cancelarEdicaoOficioRequisitorio();
    toast.success('Ofício requisitório atualizado com sucesso!');
  };

  // Funções para edição de Ofícios Expedidos - Demais Ofícios
  const iniciarEdicaoOficioDemais = (item: OficioDemaisItem) => {
    setEditandoOficioDemais(item.id);
    setValorEdicaoProcessoDemaisOficios(item.numeroProcesso);
  };

  const cancelarEdicaoOficioDemais = () => {
    setEditandoOficioDemais(null);
    setValorEdicaoProcessoDemaisOficios('');
  };

  const salvarEdicaoOficioDemais = (id: string) => {
    if (!valorEdicaoProcessoDemaisOficios.trim()) {
      toast.warning('Informe o número do processo.');
      return;
    }

    setFormData(prev => ({
      ...prev,
      oficiosExpedidos: {
        ...prev.oficiosExpedidos,
        demais: prev.oficiosExpedidos.demais.map(item =>
          item.id === id
            ? { ...item, numeroProcesso: valorEdicaoProcessoDemaisOficios.trim() }
            : item
        ),
      },
    }));

    cancelarEdicaoOficioDemais();
    toast.success('Ofício atualizado com sucesso!');
  };

  // Funções para Etapa 13 - Designação Especial (Processos)
  const adicionarDesignacaoEspecialProcesso = () => {
    if (!novoTipoPeca.trim()) {
      toast.warning('Informe o tipo de peça.');
      return;
    }
    if (!novoNumeroProcessoDesig.trim()) {
      toast.warning('Informe o número do processo.');
      return;
    }
    if (!novaDefensoriaId) {
      toast.warning('Informe a defensoria do processo/vara.');
      return;
    }

    const novoItem: DesignacaoEspecialProcessoItem = {
      id: `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
      tipoPeca: novoTipoPeca.trim(),
      numeroProcesso: novoNumeroProcessoDesig.trim(),
      defensoriaId: novaDefensoriaId,
      defensoriaLabel: getDefensoriaLabel(novaDefensoriaId),
      dataAdicao: new Date(),
    };

    setFormData(prev => ({
      ...prev,
      designacaoEspecialProcessos: {
        ...prev.designacaoEspecialProcessos,
        itens: [...prev.designacaoEspecialProcessos.itens, novoItem],
      },
    }));

    setNovoTipoPeca('');
    setNovoNumeroProcessoDesig('');
    setNovaDefensoriaId(null);
    toast.success('Item adicionado com sucesso!');
  };

  const removerDesignacaoEspecialProcesso = (id: string) => {
    setFormData(prev => ({
      ...prev,
      designacaoEspecialProcessos: {
        ...prev.designacaoEspecialProcessos,
        itens: prev.designacaoEspecialProcessos.itens.filter(item => item.id !== id),
      },
    }));
    toast.success('Item removido com sucesso!');
  };

  const adicionarMultiplasLinhasDesignacaoEspecialProcessos = () => {
    const quantidade = quantidadeLinhas.designacaoEspecialProcessos;
    if (quantidade < 1) {
      toast.warning('A quantidade mínima é 1.');
      return;
    }

    const novosItens: DesignacaoEspecialProcessoItem[] = [];
    for (let i = 0; i < quantidade; i++) {
      novosItens.push({
        id: `${Date.now()}-${Math.random().toString(36).substr(2, 9)}-${i}`,
        tipoPeca: '',
        numeroProcesso: '',
        defensoriaId: null,
        defensoriaLabel: '',
        dataAdicao: new Date(),
      });
    }

    setFormData(prev => ({
      ...prev,
      designacaoEspecialProcessos: {
        ...prev.designacaoEspecialProcessos,
        itens: [...prev.designacaoEspecialProcessos.itens, ...novosItens],
      },
    }));

    toast.success(`${quantidade} linha(s) adicionada(s) com sucesso!`);
  };

  // Funções para Etapa 14 - Designação Especial (Audiências)
  const adicionarDesignacaoEspecialAudiencia = () => {
    if (!novaAudienciaDesig.trim()) {
      toast.warning('Informe a audiência.');
      return;
    }
    if (!novoNumeroProcessoDesigAud.trim()) {
      toast.warning('Informe o número do processo.');
      return;
    }
    if (!novaDataDesigAud) {
      toast.warning('Informe a data da audiência.');
      return;
    }
    if (!novaDefensoriaIdDesigAud) {
      toast.warning('Informe a defensoria do processo/vara.');
      return;
    }

    const novoItem: DesignacaoEspecialAudienciaItem = {
      id: `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
      audiencia: novaAudienciaDesig.trim(),
      numeroProcesso: novoNumeroProcessoDesigAud.trim(),
      data: new Date(novaDataDesigAud),
      defensoriaId: novaDefensoriaIdDesigAud,
      defensoriaLabel: getDefensoriaLabel(novaDefensoriaIdDesigAud),
      dataAdicao: new Date(),
    };

    setFormData(prev => ({
      ...prev,
      designacaoEspecialAudiencias: {
        ...prev.designacaoEspecialAudiencias,
        itens: [...prev.designacaoEspecialAudiencias.itens, novoItem],
      },
    }));

    setNovaAudienciaDesig('');
    setNovoNumeroProcessoDesigAud('');
    setNovaDataDesigAud('');
    setNovaDefensoriaIdDesigAud(null);
    toast.success('Item adicionado com sucesso!');
  };

  const removerDesignacaoEspecialAudiencia = (id: string) => {
    setFormData(prev => ({
      ...prev,
      designacaoEspecialAudiencias: {
        ...prev.designacaoEspecialAudiencias,
        itens: prev.designacaoEspecialAudiencias.itens.filter(item => item.id !== id),
      },
    }));
    toast.success('Item removido com sucesso!');
  };

  const adicionarMultiplasLinhasDesignacaoEspecialAudiencias = () => {
    const quantidade = quantidadeLinhas.designacaoEspecialAudiencias;
    if (quantidade < 1) {
      toast.warning('A quantidade mínima é 1.');
      return;
    }

    const novosItens: DesignacaoEspecialAudienciaItem[] = [];
    for (let i = 0; i < quantidade; i++) {
      novosItens.push({
        id: `${Date.now()}-${Math.random().toString(36).substr(2, 9)}-${i}`,
        audiencia: '',
        numeroProcesso: '',
        data: new Date(),
        defensoriaId: null,
        defensoriaLabel: '',
        dataAdicao: new Date(),
      });
    }

    setFormData(prev => ({
      ...prev,
      designacaoEspecialAudiencias: {
        ...prev.designacaoEspecialAudiencias,
        itens: [...prev.designacaoEspecialAudiencias.itens, ...novosItens],
      },
    }));

    toast.success(`${quantidade} linha(s) adicionada(s) com sucesso!`);
  };

  // Funções para edição de Designação Especial (Processos)
  const iniciarEdicaoDesignacaoEspecialProcesso = (item: DesignacaoEspecialProcessoItem) => {
    setEditandoDesignacaoEspecialProcesso(item.id);
    setValorEdicaoTipoPeca(item.tipoPeca);
    setValorEdicaoNumeroProcessoDesig(item.numeroProcesso);
    setValorEdicaoDefensoriaId(item.defensoriaId ?? null);
  };

  const cancelarEdicaoDesignacaoEspecialProcesso = () => {
    setEditandoDesignacaoEspecialProcesso(null);
    setValorEdicaoTipoPeca('');
    setValorEdicaoNumeroProcessoDesig('');
    setValorEdicaoDefensoriaId(null);
  };

  const salvarEdicaoDesignacaoEspecialProcesso = (id: string) => {
    if (!valorEdicaoTipoPeca.trim()) {
      toast.warning('Informe o tipo de peça.');
      return;
    }
    if (!valorEdicaoNumeroProcessoDesig.trim()) {
      toast.warning('Informe o número do processo.');
      return;
    }
    if (!valorEdicaoDefensoriaId) {
      toast.warning('Informe a defensoria do processo/vara.');
      return;
    }

    setFormData(prev => ({
      ...prev,
      designacaoEspecialProcessos: {
        ...prev.designacaoEspecialProcessos,
        itens: prev.designacaoEspecialProcessos.itens.map(item =>
          item.id === id
            ? {
              ...item,
              tipoPeca: valorEdicaoTipoPeca.trim(),
              numeroProcesso: valorEdicaoNumeroProcessoDesig.trim(),
              defensoriaId: valorEdicaoDefensoriaId,
              defensoriaLabel: getDefensoriaLabel(valorEdicaoDefensoriaId),
            }
            : item
        ),
      },
    }));

    cancelarEdicaoDesignacaoEspecialProcesso();
    toast.success('Designação especial (processo) atualizada com sucesso!');
  };

  // Funções para edição de Designação Especial (Audiências)
  const iniciarEdicaoDesignacaoEspecialAudiencia = (item: DesignacaoEspecialAudienciaItem) => {
    setEditandoDesignacaoEspecialAudiencia(item.id);
    setValorEdicaoAudienciaDesig(item.audiencia);
    setValorEdicaoNumeroProcessoDesigAud(item.numeroProcesso);
    setValorEdicaoDataDesigAud(new Date(item.data).toISOString().split('T')[0]);
    setValorEdicaoDefensoriaIdDesigAud(item.defensoriaId ?? null);
  };

  const cancelarEdicaoDesignacaoEspecialAudiencia = () => {
    setEditandoDesignacaoEspecialAudiencia(null);
    setValorEdicaoAudienciaDesig('');
    setValorEdicaoNumeroProcessoDesigAud('');
    setValorEdicaoDataDesigAud('');
    setValorEdicaoDefensoriaIdDesigAud(null);
  };

  const salvarEdicaoDesignacaoEspecialAudiencia = (id: string) => {
    if (!valorEdicaoAudienciaDesig.trim()) {
      toast.warning('Informe a audiência.');
      return;
    }
    if (!valorEdicaoNumeroProcessoDesigAud.trim()) {
      toast.warning('Informe o número do processo.');
      return;
    }
    if (!valorEdicaoDataDesigAud) {
      toast.warning('Informe a data da audiência.');
      return;
    }
    if (!valorEdicaoDefensoriaIdDesigAud) {
      toast.warning('Informe a defensoria do processo/vara.');
      return;
    }

    setFormData(prev => ({
      ...prev,
      designacaoEspecialAudiencias: {
        ...prev.designacaoEspecialAudiencias,
        itens: prev.designacaoEspecialAudiencias.itens.map(item =>
          item.id === id
            ? {
              ...item,
              audiencia: valorEdicaoAudienciaDesig.trim(),
              numeroProcesso: valorEdicaoNumeroProcessoDesigAud.trim(),
              data: new Date(valorEdicaoDataDesigAud),
              defensoriaId: valorEdicaoDefensoriaIdDesigAud,
              defensoriaLabel: getDefensoriaLabel(valorEdicaoDefensoriaIdDesigAud),
            }
            : item
        ),
      },
    }));

    cancelarEdicaoDesignacaoEspecialAudiencia();
    toast.success('Designação especial (audiência) atualizada com sucesso!');
  };

  // Funções para Etapa 10 - Acordos Extrajudiciais
  const adicionarAcordoExtrajudicial = () => {
    if (!novoNomeParteAcordo.trim()) {
      toast.warning('Informe o nome da parte.');
      return;
    }
    if (!novoAnexoAcordo) {
      toast.warning('Selecione um anexo.');
      return;
    }
    if (novoAnexoAcordo.size > 10 * 1024 * 1024) {
      toast.warning('O arquivo deve ter no máximo 10MB.');
      return;
    }

    const novoItem: AcordoExtrajudicialItem = {
      id: `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
      nomeParte: novoNomeParteAcordo.trim(),
      anexo: novoAnexoAcordo,
      anexoNome: novoAnexoAcordo.name,
      dataAdicao: new Date(),
    };

    setFormData(prev => ({
      ...prev,
      acordosExtrajudiciais: {
        ...prev.acordosExtrajudiciais,
        itens: [...prev.acordosExtrajudiciais.itens, novoItem],
      },
    }));

    setNovoNomeParteAcordo('');
    setNovoAnexoAcordo(null);
    if (anexoAcordoInputRef.current) {
      anexoAcordoInputRef.current.value = '';
    }
    toast.success('Acordo extrajudicial adicionado com sucesso!');
  };

  const removerAcordoExtrajudicial = (id: string) => {
    setFormData(prev => ({
      ...prev,
      acordosExtrajudiciais: {
        ...prev.acordosExtrajudiciais,
        itens: prev.acordosExtrajudiciais.itens.filter(item => item.id !== id),
      },
    }));
    toast.success('Acordo extrajudicial removido com sucesso!');
  };

  const adicionarMultiplasLinhasAcordosExtrajudiciais = () => {
    const quantidade = quantidadeLinhas.acordosExtrajudiciais;
    if (quantidade < 1) {
      toast.warning('A quantidade mínima é 1.');
      return;
    }

    const novosItens: AcordoExtrajudicialItem[] = [];
    for (let i = 0; i < quantidade; i++) {
      novosItens.push({
        id: `${Date.now()}-${Math.random().toString(36).substr(2, 9)}-${i}`,
        nomeParte: '',
        anexo: null,
        dataAdicao: new Date(),
      });
    }

    setFormData(prev => ({
      ...prev,
      acordosExtrajudiciais: {
        ...prev.acordosExtrajudiciais,
        itens: [...prev.acordosExtrajudiciais.itens, ...novosItens],
      },
    }));

    toast.success(`${quantidade} linha(s) adicionada(s) com sucesso!`);
  };

  const meses = [
    { value: '01', label: 'Janeiro' },
    { value: '02', label: 'Fevereiro' },
    { value: '03', label: 'Março' },
    { value: '04', label: 'Abril' },
    { value: '05', label: 'Maio' },
    { value: '06', label: 'Junho' },
    { value: '07', label: 'Julho' },
    { value: '08', label: 'Agosto' },
    { value: '09', label: 'Setembro' },
    { value: '10', label: 'Outubro' },
    { value: '11', label: 'Novembro' },
    { value: '12', label: 'Dezembro' },
  ];

  const getMesLabel = (mesValue: string) => {
    const mes = meses.find(m => m.value === mesValue);
    return mes?.label || mesValue;
  };

  const mapDiasComparecimentoAdjacentes = (
    adjacentes: NonNullable<RelatorioAtividadeDto['diasComparecimentoAdjacentes']>,
  ): DiaComparecimentoStatus[] =>
    adjacentes.map((d) => ({
      dia: d.dia,
      mes: String(d.mes).padStart(2, '0'),
      ano: Number(d.ano),
      status: d.status as DiaComparecimentoStatus['status'],
      remotoValidado: d.remotoValidado,
      ausenteAceitoCorregedoria: d.ausenteAceitoCorregedoria,
      relatorioOrigemId: d.relatorioOrigemId,
      relatorioOrigemPeriodo: d.relatorioOrigemPeriodo,
    }));

  const aplicarDiasComparecimentoAdjacentes = (relatorio: RelatorioAtividadeDto | null | undefined) => {
    setDiasComparecimentoAdjacentes(
      mapDiasComparecimentoAdjacentes(relatorio?.diasComparecimentoAdjacentes ?? []),
    );
  };

  // Relatório novo (sem id): busca dias de abril/junho etc. em relatórios já concluídos
  useEffect(() => {
    if (!defensorData?.id || !formData.defensoriaId || !formData.mes || !formData.ano) {
      setDiasComparecimentoAdjacentes([]);
      return;
    }
    if (relatorioId) {
      return;
    }

    const tipo = (searchParams.get('tipo') || 'civil') as 'civil' | 'criminal';
    let cancelled = false;

    BuscarDiasComparecimentoAdjacentes(
      defensorData.id,
      formData.defensoriaId,
      formData.mes,
      formData.ano,
      tipo,
    ).then((adjacentes) => {
      if (!cancelled) {
        setDiasComparecimentoAdjacentes(mapDiasComparecimentoAdjacentes(adjacentes));
      }
    });

    return () => {
      cancelled = true;
    };
  }, [
    defensorData?.id,
    formData.defensoriaId,
    formData.mes,
    formData.ano,
    relatorioId,
    searchParams,
  ]);

  // Carregar dados do defensor e opções de natureza da ação
  useEffect(() => {
    const cpfToUse = state.cpf || getTokenPayload()?.personCPF;

    const carregarDados = async () => {
      try {
        setLoading(true);
        if (!isViewMode) {
          setRelatorioDiretoriaRegionalId(null);
        }

        // Modo visualização com ID (ex.: Corregedoria ou Diretor visualizando relatório de outro): carregar só pelo relatório, sem exigir CPF/defensor do usuário logado
        if (isViewMode && relatorioId) {
          const relatorio = await BuscarRelatorioPorId(relatorioId);
          if (!relatorio) {
            toast.error('Relatório não encontrado.');
            navigate(Links.Relatorios);
            return;
          }
          setRelatorioMetaCorregedoria({
            status: String(relatorio.status ?? '').toLowerCase(),
            corregedoriaAprovadoEm: relatorio.corregedoriaAprovadoEm,
          });
          const rawDir: unknown =
            (relatorio as RelatorioAtividadeDto & { diretoriaRegional?: { id?: number } }).diretoriaRegionalId ??
            (relatorio as RelatorioAtividadeDto & { diretoriaRegional?: { id?: number } }).diretoriaRegional?.id;
          let dirRegionalId: number | null = null;
          if (typeof rawDir === 'number' && !Number.isNaN(rawDir)) {
            dirRegionalId = rawDir;
          } else if (typeof rawDir === 'string' && rawDir.trim() !== '') {
            const n = parseInt(rawDir, 10);
            dirRegionalId = Number.isFinite(n) ? n : null;
          }
          if (dirRegionalId == null && relatorio.defensorId && relatorio.defensoriaId) {
            dirRegionalId = await IdentificarDiretoriaRegional(relatorio.defensorId, relatorio.defensoriaId);
          }
          setRelatorioDiretoriaRegionalId(dirRegionalId);
          setDefensorData({
            id: relatorio.defensorId ?? 0,
            pessoa: { nome: relatorio.defensorNome || 'Defensor' },
          } as ReadDefensorResponseDto);
          const baseForm = {
            defensoriaId: relatorio.defensoriaId,
            defensoriaName: relatorio.defensoriaName || '',
            mes: relatorio.mes ? String(relatorio.mes).padStart(2, '0') : '01',
            ano: relatorio.ano ?? new Date().getFullYear(),
          };
          aplicarDiasComparecimentoAdjacentes(relatorio);
          if (relatorio.dados) {
            const dadosRestaurados = restaurarDadosDoFormulario(relatorio.dados);
            setFormData(() => ({ ...dadosRestaurados, ...baseForm }));
          } else {
            setFormData(prev => ({ ...prev, ...baseForm }));
          }
          try {
            const tiposMovimentacoes = await ListarOpcoesMovimentacaoTipo();
            if (tiposMovimentacoes?.objects) {
              setNaturezaAcaoOptions([
                { value: '', label: 'Selecione...' },
                ...tiposMovimentacoes.objects.map((tipo: ReadMovimentacaoTipoDto) => ({
                  value: String(tipo.id),
                  label: tipo.descricao || '',
                })),
              ]);
            }
          } catch {
            // opções de natureza opcionais em modo visualização
          }
          setLoading(false);
          return;
        }

        // Fluxo normal: usuário é o defensor (requer CPF no token)
        if (!cpfToUse) {
          toast.error('CPF do defensor não foi encontrado. Por favor, faça login novamente.');
          navigate(Links.Auth_Obter_Token);
          setLoading(false);
          return;
        }

        const defensor = await BuscarDefensorPorCPF(cpfToUse);
        if (!defensor) {
          toast.error('Defensor não encontrado para o CPF informado.');
          navigate(Links.Relatorios);
          setLoading(false);
          return;
        }

        setDefensorData(defensor);

        const lotacoesData = await BuscarTodasLotacoesDefensor(defensor.id);
        const defensoriasOpcoes = ExtrairDefensoriasOpcoes(lotacoesData);
        setDefensoriasOptions(
          defensoriasOpcoes.map((d) => ({
            value: d.id,
            label: `${d.nome} - ${d.comarca}`,
          })),
        );

        const { vara: varaData } = ObterComarcaVara(defensor, lotacoesData);
        setVara(varaData);

        const titularidadeData = ObterTitularidade(defensor, lotacoesData);
        setTitularidade(titularidadeData);

        // Carregar opções de natureza da ação (tipos de movimentações)
        try {
          const tiposMovimentacoes = await ListarOpcoesMovimentacaoTipo();
          if (tiposMovimentacoes && tiposMovimentacoes.objects) {
            const opcoes: NaturezaAcaoOption[] = [
              { value: '', label: 'Selecione...' },
              ...tiposMovimentacoes.objects.map((tipo: ReadMovimentacaoTipoDto) => ({
                value: String(tipo.id),
                label: tipo.descricao || '',
              })),
            ];
            setNaturezaAcaoOptions(opcoes);
          }
        } catch (errorTipos) {
          console.error('Erro ao carregar tipos de movimentações:', errorTipos);
        }

        try {
          const periodos = await GetPeriodosDoDefensorPorCpf(cpfToUse);
          if (periodos?.objects) setPeriodosDefensor(periodos.objects);
        } catch (errorPeriodos) {
          console.error('Erro ao carregar períodos do defensor:', errorPeriodos);
        }

        if (relatorioId) {
          try {
            const relatorio = await BuscarRelatorioPorId(relatorioId);
            if (relatorio) {
              if (!isViewMode && !defensorPodeAbrirEditorDoRelatorioAtividade(relatorio.status)) {
                toast.warning(
                  'Este relatório já foi enviado ou não pode mais ser editado. Redirecionando para visualização.',
                );
                const params = new URLSearchParams({
                  id: String(relatorioId),
                  defensoriaId: String(relatorio.defensoriaId),
                  defensoriaName: relatorio.defensoriaName || '',
                  mes: relatorio.mes ? String(relatorio.mes).padStart(2, '0') : '01',
                  ano: String(relatorio.ano),
                  tipo: relatorio.tipo,
                  view: 'true',
                });
                navigate(`${Links.Relatorios_Criar}?${params.toString()}`, { replace: true });
                setLoading(false);
                return;
              }
              setMetaReenvioCorregedoria(
                relatorio.status === 'reprovado' &&
                relatorio.dados?.reenvioDiretoCorregedoriaPendente === true,
              );
            }
            aplicarDiasComparecimentoAdjacentes(relatorio);
            if (relatorio?.dados) {
              const dadosRestaurados = restaurarDadosDoFormulario(relatorio.dados);
              setFormData(prev => ({
                ...dadosRestaurados,
                defensoriaId: relatorio.defensoriaId,
                defensoriaName: relatorio.defensoriaName || prev.defensoriaName,
                mes: relatorio.mes ? String(relatorio.mes).padStart(2, '0') : prev.mes,
                ano: relatorio.ano || prev.ano,
              }));
            }
          } catch (errorRelatorio) {
            console.error('Erro ao carregar relatório:', errorRelatorio);
            toast.warning('Não foi possível carregar os dados do relatório. Continuando com formulário vazio.');
          }
        }
      } catch (error) {
        console.error('Erro ao carregar dados:', error);
        toast.error('Erro ao carregar dados do defensor.');
      } finally {
        setLoading(false);
      }
    };
    carregarDados();
  }, [state.cpf, state.username, navigate, relatorioId, isViewMode]);

  useEffect(() => {
    if (!isViewMode) {
      setDiretoriaUsuarioId(null);
      return;
    }
    let cancelled = false;
    (async () => {
      try {
        const diretoriaUsuario = await GetDiretoriaDoUsuario();
        if (!cancelled) setDiretoriaUsuarioId(diretoriaUsuario?.id ?? null);
      } catch {
        if (!cancelled) setDiretoriaUsuarioId(null);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [isViewMode]);

  useEffect(() => {
    if (!isViewMode) {
      setDefensorLogadoIdView(null);
      return;
    }
    let cancelled = false;
    (async () => {
      const cpfToUse = state.cpf || getTokenPayload()?.personCPF;
      if (cpfToUse) {
        try {
          const defensor = await BuscarDefensorPorCPF(cpfToUse);
          if (!cancelled) setDefensorLogadoIdView(defensor?.id ?? null);
        } catch {
          if (!cancelled) setDefensorLogadoIdView(null);
        }
        return;
      }
      if (state.username) {
        try {
          const usuario = await GetUsuarioBy(state.username);
          const pessoaId = usuario?.pessoa?.id;
          if (pessoaId) {
            const defensor = await BuscarDefensorPorPessoaId(String(pessoaId));
            if (!cancelled) setDefensorLogadoIdView(defensor?.id ?? null);
          } else if (!cancelled) {
            setDefensorLogadoIdView(null);
          }
        } catch {
          if (!cancelled) setDefensorLogadoIdView(null);
        }
        return;
      }
      if (!cancelled) setDefensorLogadoIdView(null);
    })();
    return () => {
      cancelled = true;
    };
  }, [isViewMode, state.cpf, state.username]);

  const getTitularidadeLabel = (tipo: string): { label: string; variant: string } => {
    switch (tipo) {
      case 'titular':
        return { label: 'Titular', variant: 'success' };
      case 'substituto':
        return { label: 'Substituto', variant: 'info' };
      case 'cedido':
        return { label: 'Cedido', variant: 'warning' };
      default:
        return { label: 'Não definido', variant: 'secondary' };
    }
  };

  // Funções de navegação do wizard
  const handleNextStep = async () => {
    if (currentStep < WIZARD_STEPS.length) {
      // Salvar automaticamente antes de trocar de etapa (apenas se não estiver em modo visualização)
      if (!isViewMode) {
        await autoSave();
      }
      setCurrentStep(currentStep + 1);
    }
  };

  const handleGoToStep = async (step: number) => {
    // Salvar automaticamente antes de trocar de etapa (apenas se não estiver em modo visualização)
    if (!isViewMode) {
      await autoSave();
    }
    setCurrentStep(step);
  };

  // Verifica se o mês do relatório já terminou
  const mesRelatorioTerminado = useMemo(() => {
    const mesRelatorio = parseInt(formData.mes);
    const anoRelatorio = formData.ano;
    const dataAtual = new Date();
    const anoAtual = dataAtual.getFullYear();
    const mesAtual = dataAtual.getMonth() + 1; // getMonth() retorna 0-11

    // Se o ano do relatório for menor que o ano atual, o mês já terminou
    if (anoRelatorio < anoAtual) {
      return true;
    }

    // Se o ano do relatório for igual ao ano atual, verificar se o mês já passou
    if (anoRelatorio === anoAtual) {
      // Se o mês do relatório for menor que o mês atual, já terminou
      if (mesRelatorio < mesAtual) {
        return true;
      }
      // Se estamos no mesmo mês, ainda não terminou
      if (mesRelatorio === mesAtual) {
        return false;
      }
      // Se o mês do relatório for maior que o mês atual, ainda não terminou (futuro)
      return false;
    }

    // Se o ano do relatório for maior que o ano atual, ainda não terminou (futuro)
    return false;
  }, [formData.ano, formData.mes]);

  // Função auxiliar para converter File para base64
  const fileToBase64 = (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const result = reader.result as string;
        resolve(result);
      };
      reader.onerror = (error) => reject(error);
    });
  };

  // Função auxiliar para converter base64 para File
  const base64ToFile = (base64: string, filename: string, mimeType: string): File => {
    const arr = base64.split(',');
    const mime = arr[0].match(/:(.*?);/)?.[1] || mimeType;
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  };

  type DiaStatusSerializado = Omit<DiaComparecimentoStatus, 'justificativaArquivo'> & {
    justificativaArquivo?: File | null;
    justificativaArquivoBase64?: string;
    justificativaArquivoNome?: string;
  };

  type AcordoExtrajudicialSerializado = Omit<AcordoExtrajudicialItem, 'anexo'> & {
    anexo: File | null;
    anexoBase64?: string;
    anexoNome?: string;
  };

  type AtendimentoSerializado = Omit<AtendimentoPresencialItem | AtendimentoRemotoItem, 'arquivo'> & {
    arquivo: File | null;
    arquivoBase64?: string;
    arquivoNome?: string;
  };

  type RelatorioCivelFormDataSerializado = Omit<RelatorioCivelFormData, 'comparecimento' | 'acordosExtrajudiciais' | 'atendimento'> & {
    comparecimento: Omit<RelatorioCivelFormData['comparecimento'], 'diasStatus'> & { diasStatus: DiaStatusSerializado[] };
    acordosExtrajudiciais: Omit<RelatorioCivelFormData['acordosExtrajudiciais'], 'itens'> & { itens: AcordoExtrajudicialSerializado[] };
    atendimento: Omit<RelatorioCivelFormData['atendimento'], 'presenciais' | 'remotas'> & {
      presenciais: AtendimentoSerializado[];
      remotas: AtendimentoSerializado[];
    };
  };

  // Função para preparar dados do formulário para salvar (converter Files para base64)
  const prepararDadosParaSalvar = async (dados: RelatorioCivelFormData): Promise<RelatorioCivelFormDataSerializado> => {
    // Processar arquivos ANTES da serialização JSON (para preservar File objects)
    // Criar estrutura de dados para processar
    const dadosParaProcessar: RelatorioCivelFormDataSerializado = {
      ...dados,
      comparecimento: {
        ...dados.comparecimento,
        diasStatus: dados.comparecimento.diasStatus.map((d) => ({ ...d })),
      },
      acordosExtrajudiciais: {
        ...dados.acordosExtrajudiciais,
        itens: dados.acordosExtrajudiciais.itens.map((i) => ({ ...i })),
      },
      atendimento: {
        ...dados.atendimento,
        presenciais: dados.atendimento.presenciais.map((a) => ({ ...a })),
        remotas: dados.atendimento.remotas.map((a) => ({ ...a })),
      },
    };

    // Converter arquivos em diasStatus (justificativas)
    if (dadosParaProcessar.comparecimento?.diasStatus) {
      for (let idx = 0; idx < dadosParaProcessar.comparecimento.diasStatus.length; idx++) {
        const diaStatus = dadosParaProcessar.comparecimento.diasStatus[idx];
        const arquivo = dados.comparecimento.diasStatus[idx]?.justificativaArquivo ?? null;
        if (arquivo instanceof File) {
          diaStatus.justificativaArquivoBase64 = await fileToBase64(arquivo);
          diaStatus.justificativaArquivoNome = arquivo.name;
        }
        diaStatus.justificativaArquivo = null;
      }
    }

    // Converter arquivos em acordosExtrajudiciais
    if (dadosParaProcessar.acordosExtrajudiciais?.itens) {
      for (let idx = 0; idx < dadosParaProcessar.acordosExtrajudiciais.itens.length; idx++) {
        const acordo = dadosParaProcessar.acordosExtrajudiciais.itens[idx];
        const anexo = dados.acordosExtrajudiciais.itens[idx]?.anexo ?? null;
        if (anexo instanceof File) {
          acordo.anexoBase64 = await fileToBase64(anexo);
          acordo.anexoNome = anexo.name;
        }
        acordo.anexo = null;
      }
    }

    // Converter arquivos em atendimentos presenciais (EXATAMENTE como em remotos)
    if (dadosParaProcessar.atendimento?.presenciais) {
      for (let idx = 0; idx < dadosParaProcessar.atendimento.presenciais.length; idx++) {
        const atendimento = dadosParaProcessar.atendimento.presenciais[idx];
        const arquivo = dados.atendimento.presenciais[idx]?.arquivo ?? null;
        if (arquivo instanceof File) {
          atendimento.arquivoBase64 = await fileToBase64(arquivo);
          atendimento.arquivoNome = arquivo.name;
        }
        atendimento.arquivo = null;
      }
    }

    // Converter arquivos em atendimentos remotos
    if (dadosParaProcessar.atendimento?.remotas) {
      for (let idx = 0; idx < dadosParaProcessar.atendimento.remotas.length; idx++) {
        const atendimento = dadosParaProcessar.atendimento.remotas[idx];
        const arquivo = dados.atendimento.remotas[idx]?.arquivo ?? null;
        if (arquivo instanceof File) {
          atendimento.arquivoBase64 = await fileToBase64(arquivo);
          atendimento.arquivoNome = arquivo.name;
        }
        atendimento.arquivo = null;
      }
    }

    // Agora serializar para JSON (File objects já foram convertidos ou limpos)
    const dadosSerializados = JSON.parse(JSON.stringify(dadosParaProcessar)) as RelatorioCivelFormDataSerializado;

    return dadosSerializados;
  };

  // Função para restaurar dados do formulário (converter base64 para Files e strings para Dates)
  const restaurarDadosDoFormulario = (dados: unknown): RelatorioCivelFormData => {
    const structuredCloneFn = (globalThis as unknown as { structuredClone?: <T>(value: T) => T }).structuredClone;
    const dadosRestaurados = (structuredCloneFn
      ? structuredCloneFn(dados)
      : JSON.parse(JSON.stringify(dados))) as RelatorioCivelFormDataSerializado;

    const restoreDateIfString = <T extends Record<string, unknown>>(obj: T, key: keyof T) => {
      const value = obj[key];
      if (typeof value === 'string' && value) {
        obj[key] = new Date(value) as unknown as T[keyof T];
      }
    };

    const restoreFileFromBase64 = <
      T extends {
        [k: string]: unknown;
      },
    >(
      obj: T,
      opts: {
        base64Key: keyof T;
        nomeKey: keyof T;
        targetKey: keyof T;
        defaultFilename: string;
        mimeType: string;
      },
    ) => {
      const base64 = obj[opts.base64Key];
      if (typeof base64 === 'string' && base64) {
        const filenameRaw = obj[opts.nomeKey];
        const filename = typeof filenameRaw === 'string' && filenameRaw ? filenameRaw : opts.defaultFilename;
        obj[opts.targetKey] = base64ToFile(base64, filename, opts.mimeType) as unknown as T[keyof T];
        delete obj[opts.base64Key];
      }
    };

    // Restaurar arquivos e datas em diasStatus (justificativas) e normalizar mes/ano
    if (dadosRestaurados.comparecimento?.diasStatus) {
      for (const diaStatus of dadosRestaurados.comparecimento.diasStatus) {
        restoreFileFromBase64(diaStatus as unknown as Record<string, unknown>, {
          base64Key: 'justificativaArquivoBase64',
          nomeKey: 'justificativaArquivoNome',
          targetKey: 'justificativaArquivo',
          defaultFilename: 'anexo.pdf',
          mimeType: 'application/pdf',
        });
        // Normalizar mes/ano para formato consistente (todas as semanas do calendário)
        if (diaStatus.mes != null) diaStatus.mes = String(diaStatus.mes).padStart(2, '0');
        if (diaStatus.ano != null) diaStatus.ano = Number(diaStatus.ano);
      }
    }

    // Restaurar arquivos em acordosExtrajudiciais
    if (dadosRestaurados.acordosExtrajudiciais?.itens) {
      for (const acordo of dadosRestaurados.acordosExtrajudiciais.itens) {
        restoreFileFromBase64(acordo as unknown as Record<string, unknown>, {
          base64Key: 'anexoBase64',
          nomeKey: 'anexoNome',
          targetKey: 'anexo',
          defaultFilename: 'anexo.pdf',
          mimeType: 'application/pdf',
        });
      }
    }

    // Restaurar arquivos em atendimentos presenciais (EXATAMENTE como em remotos)
    if (dadosRestaurados.atendimento?.presenciais) {
      for (const atendimento of dadosRestaurados.atendimento.presenciais) {
        // Criar File object para exibição/edição (mantendo arquivoBase64 preservado)
        const base64 = (atendimento as unknown as { arquivoBase64?: unknown }).arquivoBase64;
        if (typeof base64 === 'string' && base64) {
          const filename = (atendimento as unknown as { arquivoNome?: unknown }).arquivoNome;
          atendimento.arquivo = base64ToFile(
            base64,
            typeof filename === 'string' && filename ? filename : 'anexo.pdf',
            'application/pdf'
          );
        }
      }
    }

    // Restaurar arquivos em atendimentos remotos
    if (dadosRestaurados.atendimento?.remotas) {
      for (const atendimento of dadosRestaurados.atendimento.remotas) {
        // Criar File object para exibição/edição (mantendo arquivoBase64 preservado)
        const base64 = (atendimento as unknown as { arquivoBase64?: unknown }).arquivoBase64;
        if (typeof base64 === 'string' && base64) {
          const filename = (atendimento as unknown as { arquivoNome?: unknown }).arquivoNome;
          atendimento.arquivo = base64ToFile(
            base64,
            typeof filename === 'string' && filename ? filename : 'anexo.pdf',
            'application/pdf'
          );
        }
      }
    }

    // Converter datas em audiências presenciais
    if (dadosRestaurados.audiencias?.presenciais) {
      for (const audiencia of dadosRestaurados.audiencias.presenciais) {
        restoreDateIfString(audiencia as unknown as Record<string, unknown>, 'data');
      }
    }

    // Converter datas em audiências remotas
    if (dadosRestaurados.audiencias?.remotas) {
      for (const audiencia of dadosRestaurados.audiencias.remotas) {
        restoreDateIfString(audiencia as unknown as Record<string, unknown>, 'data');
      }
    }

    // Converter datas em designação especial (audiências)
    if (dadosRestaurados.designacaoEspecialAudiencias?.itens) {
      for (const item of dadosRestaurados.designacaoEspecialAudiencias.itens) {
        restoreDateIfString(item as unknown as Record<string, unknown>, 'data');
      }
    }

    // Converter datas em acordos extrajudiciais
    if (dadosRestaurados.acordosExtrajudiciais?.itens) {
      for (const acordo of dadosRestaurados.acordosExtrajudiciais.itens) {
        restoreDateIfString(acordo as unknown as Record<string, unknown>, 'dataAdicao');
      }
    }

    // Converter datas em autorNatureza
    if (dadosRestaurados.autorNatureza?.itens) {
      for (const item of dadosRestaurados.autorNatureza.itens) {
        restoreDateIfString(item as unknown as Record<string, unknown>, 'dataAdicao');
      }
    }

    // Converter datas em honorários
    if (dadosRestaurados.honorarios?.sentencaAcordao) {
      for (const item of dadosRestaurados.honorarios.sentencaAcordao) {
        restoreDateIfString(item as unknown as Record<string, unknown>, 'dataAdicao');
      }
    }
    if (dadosRestaurados.honorarios?.cumprimento) {
      for (const item of dadosRestaurados.honorarios.cumprimento) {
        restoreDateIfString(item as unknown as Record<string, unknown>, 'dataAdicao');
      }
    }

    // Converter datas em ofícios expedidos
    if (dadosRestaurados.oficiosExpedidos?.requisitorios) {
      for (const item of dadosRestaurados.oficiosExpedidos.requisitorios) {
        restoreDateIfString(item as unknown as Record<string, unknown>, 'dataAdicao');
      }
    }
    if (dadosRestaurados.oficiosExpedidos?.demais) {
      for (const item of dadosRestaurados.oficiosExpedidos.demais) {
        restoreDateIfString(item as unknown as Record<string, unknown>, 'dataAdicao');
      }
    }

    // Converter datas em designação especial (processos)
    // Não há datas neste tipo, então não precisa converter

    return dadosRestaurados as RelatorioCivelFormData;
  };

  const podeCorregedoriaAgirComparecimento =
    isViewMode &&
    origemVisualizacao === 'corregedoria' &&
    !!relatorioId &&
    relatorioMetaCorregedoria?.status === 'aprovado' &&
    !relatorioMetaCorregedoria?.corregedoriaAprovadoEm;

  const diasComparecimentoCorregedoriaPendentes = useMemo(() => {
    const dias = formData.comparecimento.diasStatus || [];
    return dias.filter(
      (d) =>
        (d.status === 'remoto' && d.remotoValidado !== true) ||
        (d.status === 'ausente' && d.ausenteAceitoCorregedoria !== true),
    );
  }, [formData.comparecimento.diasStatus]);

  const aplicarDecisaoCorregedoriaNoDia = async (
    dia: DiaComparecimentoStatus,
    acao: ComparecimentoDecisaoAcao,
  ) => {
    if (!relatorioId || !podeCorregedoriaAgirComparecimento) return;
    const mes = String(dia.mes ?? formData.mes).padStart(2, '0');
    const ano = dia.ano ?? formData.ano;
    const rowKey = `${dia.dia}-${mes}-${ano}`;
    setCorregedoriaDecisaoDiaLoading(rowKey);
    try {
      await AplicarDecisoesComparecimentoCorregedoria(relatorioId, [
        { dia: dia.dia, mes, ano, acao },
      ]);
      const relatorio = await BuscarRelatorioPorId(relatorioId);
      aplicarDiasComparecimentoAdjacentes(relatorio);
      if (relatorio?.dados) {
        const dadosRestaurados = restaurarDadosDoFormulario(relatorio.dados);
        setFormData((prev) => ({
          ...dadosRestaurados,
          defensoriaId: relatorio.defensoriaId,
          defensoriaName: relatorio.defensoriaName || prev.defensoriaName,
          mes: relatorio.mes ? String(relatorio.mes).padStart(2, '0') : prev.mes,
          ano: relatorio.ano ?? prev.ano,
        }));
      }
      if (relatorio) {
        setRelatorioMetaCorregedoria({
          status: relatorio.status,
          corregedoriaAprovadoEm: relatorio.corregedoriaAprovadoEm,
        });
      }
      toast.success('Decisão da Corregedoria registrada.');
    } catch (e: unknown) {
      const err = e as { response?: { data?: { message?: string } }; message?: string };
      toast.error(err?.response?.data?.message || err?.message || 'Erro ao registrar decisão.');
    } finally {
      setCorregedoriaDecisaoDiaLoading(null);
    }
  };

  // Função para auto-save (salvar automaticamente ao trocar de etapa)
  const autoSave = async () => {
    if (!defensorData || !formData.defensoriaId) {
      return; // Não salva se não tiver dados básicos
    }

    try {
      const dadosParaSalvar = await prepararDadosParaSalvar(formData);
      const resultado = await AutoSaveRelatorio(
        defensorData.id,
        formData.defensoriaId,
        formData.mes,
        formData.ano,
        'civil',
        dadosParaSalvar
      );

      // Atualizar o ID do relatório se foi criado
      if (resultado.id && !relatorioId) {
        setRelatorioId(resultado.id);
        // Atualizar URL com o ID
        const params = new URLSearchParams(searchParams.toString());
        params.set('id', String(resultado.id));
        navigate(`${Links.Relatorios_Criar}?${params.toString()}`, { replace: true });
      }
    } catch (error) {
      console.error('Erro ao salvar automaticamente:', error);
      // Não mostra toast de erro para auto-save silencioso
    }
  };

  const handleSave = useCallback(async (apenasRascunho: boolean = true, manterNaTela: boolean = false) => {
    try {
      setSaving(true);

      if (!defensorData) {
        toast.error('Dados do defensor não carregados.');
        return;
      }

      if (!formData.defensoriaId) {
        toast.error('Defensoria não informada.');
        return;
      }

      const dadosParaSalvar = await prepararDadosParaSalvar(formData);

      if (!apenasRascunho && metaReenvioCorregedoria && relatorioId) {
        await SalvarRelatorio(
          defensorData.id,
          formData.defensoriaId,
          formData.mes,
          formData.ano,
          'civil',
          dadosParaSalvar,
          'reprovado',
          relatorioId,
        );
        await EnviarDiretoCorregedoriaDefensor(relatorioId);
        toast.success('Relatório encaminhado diretamente à Corregedoria.');
        if (!manterNaTela) {
          navigate(Links.Relatorios);
        }
        return;
      }

      const status = apenasRascunho ? 'rascunho' : 'enviado';

      const resultado = await SalvarRelatorio(
        defensorData.id,
        formData.defensoriaId,
        formData.mes,
        formData.ano,
        'civil',
        dadosParaSalvar,
        status,
        relatorioId || undefined
      );

      // Atualizar o ID do relatório se foi criado
      if (resultado.id && !relatorioId) {
        setRelatorioId(resultado.id);
        // Mantém o usuário na tela do relatório, mas atualiza a URL com o ID
        const params = new URLSearchParams(searchParams.toString());
        params.set('id', String(resultado.id));
        navigate(`${Links.Relatorios_Criar}?${params.toString()}`, { replace: true });
      }

      if (apenasRascunho) {
        toast.success('Relatório salvo como rascunho!');
        return; // permanece na tela
      } else {
        toast.success('Relatório enviado com sucesso!');
      }

      if (!manterNaTela) {
        navigate(Links.Relatorios);
      }
    } catch (error: unknown) {
      console.error('Erro ao salvar relatório:', error);
      const maybeAxios = error as { response?: { data?: { message?: string } } };
      const mensagem = maybeAxios?.response?.data?.message || 'Erro ao salvar relatório.';
      toast.error(mensagem);
    } finally {
      setSaving(false);
    }
  }, [
    defensorData,
    formData,
    metaReenvioCorregedoria,
    navigate,
    relatorioId,
    searchParams,
  ]);

  // Evita loop de render no breadcrumb: mantém callbacks estáveis via refs
  const handleNextStepRef = useRef(handleNextStep);
  const handleSaveRef = useRef(handleSave);

  useEffect(() => {
    handleNextStepRef.current = handleNextStep;
  }, [handleNextStep]);

  useEffect(() => {
    handleSaveRef.current = handleSave;
  }, [handleSave]);

  useEffect(() => {
    const sendLabel = metaReenvioCorregedoria ? 'Enviar à Corregedoria' : 'Enviar Relatório';

    setActions({
      primary:
        !isViewMode
          ? {
            label: sendLabel,
            variant: 'primary',
            onClick: () => {
              if (saving) return;
              if (!mesRelatorioTerminado) {
                toast.warning('O relatório ainda não pode ser enviado devido ao prazo.');
                return;
              }
              setShowEnviarModal(true);
            },
          }
          : undefined,
      secondary: isViewMode
        ? {
          label: 'Voltar para Lista',
          onClick: () => navigate(-1),
        }
        : {
          label: saving ? 'Salvando...' : 'Salvar Alterações',
          onClick: () => {
            if (saving) return;
            handleSaveRef.current(true, true);
          },
        },
      print: {
        label: 'Resumo',
        onClick: () => setShowResumoModal(true),
      },
      history: {
        label: 'Sair',
        dropdownOptions: [
          {
            label: 'Escolha de módulo',
            onClick: () => {
              window.location.href = Links.Escolha_Modulo;
            },
          },
          {
            label: 'Sair',
            onClick: () => {
              window.location.href = Links.Auth_Logout;
            },
          },
        ],
        onClick: () => { },
      },
    });

    return () => setActions({});
  }, [
    currentStep,
    isViewMode,
    mesRelatorioTerminado,
    metaReenvioCorregedoria,
    navigate,
    saving,
    setActions,
  ]);

  // Funções auxiliares para o calendário

  // Retorna os feriados que caem exatamente na data informada (considerando intervalos de início/fim)
  const getFeriadosNaData = (data: Date): ReadHolidayResponseDto[] => {
    return feriados.filter((feriado) => {
      const dataInicio = new Date(feriado.inicio);
      const dataFim = feriado.fim ? new Date(feriado.fim) : null;

      if (
        dataInicio.getFullYear() === data.getFullYear() &&
        dataInicio.getMonth() === data.getMonth() &&
        dataInicio.getDate() === data.getDate()
      ) {
        return true;
      }

      if (dataFim) {
        const dataSelecionadaTime = new Date(
          data.getFullYear(),
          data.getMonth(),
          data.getDate()
        ).getTime();
        const inicioTime = new Date(
          dataInicio.getFullYear(),
          dataInicio.getMonth(),
          dataInicio.getDate()
        ).getTime();
        const fimTime = new Date(
          dataFim.getFullYear(),
          dataFim.getMonth(),
          dataFim.getDate()
        ).getTime();

        return dataSelecionadaTime >= inicioTime && dataSelecionadaTime <= fimTime;
      }

      return false;
    });
  };
  const gerarCalendarioMensal = (mes: string, ano: number) => {
    const mesNum = parseInt(mes) - 1; // JavaScript usa mês 0-indexed
    const primeiroDia = new Date(ano, mesNum, 1);
    const ultimoDia = new Date(ano, mesNum + 1, 0);
    const diasNoMes = ultimoDia.getDate();
    const diaDaSemanaInicio = primeiroDia.getDay(); // 0 = Domingo

    // Calcular mês anterior e posterior
    const mesAnterior = mesNum === 0 ? 11 : mesNum - 1;
    const anoAnterior = mesNum === 0 ? ano - 1 : ano;
    const diasNoMesAnterior = new Date(anoAnterior, mesAnterior + 1, 0).getDate();

    const mesPosterior = mesNum === 11 ? 0 : mesNum + 1;
    const anoPosterior = mesNum === 11 ? ano + 1 : ano;

    // Criar matriz de semanas
    const semanas: (DiaCalendario | null)[][] = [];
    let semanaAtual: (DiaCalendario | null)[] = [];

    // Preencher dias do mês anterior antes do primeiro dia do mês
    let diaAnterior = diasNoMesAnterior - diaDaSemanaInicio + 1;
    for (let i = 0; i < diaDaSemanaInicio; i++) {
      semanaAtual.push({
        dia: diaAnterior,
        mes: String(mesAnterior + 1).padStart(2, '0'),
        ano: anoAnterior,
        isMesAtual: false,
      });
      diaAnterior++;
    }

    // Preencher os dias do mês atual (sempre mes/ano normalizados para todas as linhas)
    const mesNorm = String(mes).padStart(2, '0');
    const anoNorm = Number(ano);
    for (let dia = 1; dia <= diasNoMes; dia++) {
      semanaAtual.push({
        dia: dia,
        mes: mesNorm,
        ano: anoNorm,
        isMesAtual: true,
      });
      if (semanaAtual.length === 7) {
        semanas.push(semanaAtual);
        semanaAtual = [];
      }
    }

    // Preencher dias do mês posterior após o último dia do mês
    if (semanaAtual.length > 0) {
      let diaPosterior = 1;
      while (semanaAtual.length < 7) {
        semanaAtual.push({
          dia: diaPosterior,
          mes: String(mesPosterior + 1).padStart(2, '0'),
          ano: anoPosterior,
          isMesAtual: false,
        });
        diaPosterior++;
      }
      semanas.push(semanaAtual);
    }

    return semanas;
  };

  // Verificar se o dia é útil (não é fim de semana nem feriado/bloqueio)
  const isDiaUtil = (dia: number, mes: string, ano: number) => {
    const data = new Date(ano, parseInt(mes) - 1, dia);
    const diaSemana = data.getDay();
    if (diaSemana === 0 || diaSemana === 6) {
      return false; // Não é domingo nem sábado
    }

    const feriadosNaData = getFeriadosNaData(data);
    if (feriadosNaData.length > 0) {
      return false; // Dia de feriado/bloqueio não é dia útil
    }

    // Férias não geram obrigação de presença (mesmo tratamento de feriado/bloqueio)
    const impedimento = getImpedimentoDia(dia, mes, ano);
    if (impedimento?.tipo === TipoPeriodoDescanso.Ferias) {
      return false;
    }

    return true;
  };

  // Verificar se o dia é futuro (bloqueado para marcação)
  const isDiaFuturo = (dia: number, mes: string, ano: number) => {
    const dataAtual = new Date();
    dataAtual.setHours(0, 0, 0, 0);
    const dataDia = new Date(ano, parseInt(mes) - 1, dia);
    dataDia.setHours(0, 0, 0, 0);
    return dataDia > dataAtual;
  };

  // Verificar se um dia tem impedimento (férias, abono, folga, licença, etc.)
  const getImpedimentoDia = (dia: number, mes: string, ano: number): ReadPeriodoDto | null => {
    const dataDia = new Date(ano, parseInt(mes) - 1, dia);
    dataDia.setHours(0, 0, 0, 0);

    for (const periodo of periodosDefensor) {
      const dataInicial = new Date(periodo.data_inicial);
      const dataFinal = new Date(periodo.data_final);
      dataInicial.setHours(0, 0, 0, 0);
      dataFinal.setHours(23, 59, 59, 999);

      if (dataDia >= dataInicial && dataDia <= dataFinal) {
        return periodo;
      }
    }

    return null;
  };

  // Obter status de um dia específico (compara mês/ano normalizados para evitar "02" vs "2")
  const getStatusDia = (dia: number, mes?: string, ano?: number): DiaComparecimentoStatus | undefined => {
    const mesBusca = String(mes || formData.mes).padStart(2, '0');
    const anoBusca = Number(ano ?? formData.ano);
    const matchDia = (d: DiaComparecimentoStatus) => {
      if (d.dia !== dia) return false;
      const dMes = d.mes === undefined ? mesBusca : String(d.mes).padStart(2, '0');
      const dAno = d.ano === undefined ? anoBusca : Number(d.ano);
      return dMes === mesBusca && dAno === anoBusca;
    };
    const local = formData.comparecimento.diasStatus.find(matchDia);
    if (local) return local;
    return diasComparecimentoAdjacentes.find(matchDia);
  };

  // Atualizar status de um dia
  const atualizarStatusDia = (
    dia: number,
    status: 'presente' | 'ausente' | 'remoto' | 'impedimento' | 'nao_marcado',
    justificativaTexto?: string,
    justificativaArquivo?: File | null,
    tipoImpedimento?: TipoPeriodoDescanso,
    impedimentoDescricao?: string,
    mes?: string, // Mês do dia (opcional, padrão é o mês do relatório)
    ano?: number  // Ano do dia (opcional, padrão é o ano do relatório)
  ) => {
    // Verificar se o dia pertence ao período do relatório atual (comparação normalizada)
    const mesDia = String(mes || formData.mes).padStart(2, '0');
    const anoDia = Number(ano ?? formData.ano);
    const mesRel = String(formData.mes).padStart(2, '0');
    const anoRel = Number(formData.ano);
    if (mesDia !== mesRel || anoDia !== anoRel) {
      toast.warning(`Este dia pertence ao período de ${getMesLabel(mesDia)}/${anoDia} e não pode ser editado no relatório de ${getMesLabel(formData.mes)}/${formData.ano}.`);
      return;
    }

    // Não há limite máximo de presenças por semana, apenas mínimo obrigatório.

    setFormData(prev => {
      const diasStatus = [...prev.comparecimento.diasStatus];
      const mesPrev = String(prev.mes).padStart(2, '0');
      const anoPrev = Number(prev.ano);
      const index = diasStatus.findIndex(d => {
        if (d.dia !== dia) return false;
        const dMes = d.mes === undefined ? mesPrev : String(d.mes).padStart(2, '0');
        const dAno = d.ano === undefined ? anoPrev : Number(d.ano);
        return dMes === mesPrev && dAno === anoPrev;
      });

      if (status === 'nao_marcado') {
        // Remover o dia da lista
        if (index >= 0) {
          diasStatus.splice(index, 1);
        }
      } else {
        const novoStatus: DiaComparecimentoStatus = {
          dia,
          mes: String(prev.mes).padStart(2, '0'),
          ano: Number(prev.ano),
          status,
          justificativaTexto: justificativaTexto || '',
          justificativaArquivo: justificativaArquivo || null,
          justificativaArquivoNome: justificativaArquivo?.name || '',
          tipoImpedimento,
          impedimentoDescricao,
        };

        if (index >= 0) {
          diasStatus[index] = novoStatus;
        } else {
          diasStatus.push(novoStatus);
        }
      }

      // Contar dias presentes (apenas 'presente'; 'remoto' só conta após validação da corregedoria)
      const diasPresentes = diasStatus.filter(d => d.status === 'presente').length;

      return {
        ...prev,
        comparecimento: {
          ...prev.comparecimento,
          diasStatus: diasStatus.sort((a, b) => a.dia - b.dia),
          diasComparecimento: diasPresentes,
        },
      };
    });
  };

  // Abrir modal de justificativa
  const abrirJustificativaModal = (dia: number, mes?: string, ano?: number) => {
    const mesBusca = mes || formData.mes;
    const anoBusca = ano || formData.ano;

    // Verificar se o dia pertence ao período do relatório atual
    if (mesBusca !== formData.mes || anoBusca !== formData.ano) {
      toast.warning(`Este dia pertence ao período de ${getMesLabel(mesBusca)}/${anoBusca} e não pode ser editado no relatório de ${getMesLabel(formData.mes)}/${formData.ano}.`);
      return;
    }
    const status = getStatusDia(dia, mesBusca, anoBusca);
    setJustificativaTextoTemp(status?.justificativaTexto || '');
    setJustificativaArquivoTemp(status?.justificativaArquivo || null);
    // Usar setTimeout para evitar que o rootClose feche imediatamente
    setTimeout(() => {
      setJustificativaModalDia(dia);
    }, 100);
  };

  // Salvar justificativa
  const salvarJustificativa = () => {
    if (justificativaModalDia !== null) {
      // O dia já foi validado ao abrir o modal, então podemos usar o mês/ano do relatório atual
      atualizarStatusDia(
        justificativaModalDia,
        'ausente',
        justificativaTextoTemp,
        justificativaArquivoTemp,
        undefined,
        undefined,
        formData.mes,
        formData.ano
      );
      setJustificativaModalDia(null);
      setJustificativaTextoTemp('');
      setJustificativaArquivoTemp(null);
    }
  };

  // Cancelar justificativa
  const cancelarJustificativa = () => {
    setJustificativaModalDia(null);
    setJustificativaTextoTemp('');
    setJustificativaArquivoTemp(null);
  };

  // Handler para mudança de arquivo
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0] || null;
    setJustificativaArquivoTemp(file);
  };

  const getNomeSemana = (index: number) => {
    const nomes = ['1ª Semana', '2ª Semana', '3ª Semana', '4ª Semana', '5ª Semana', '6ª Semana'];
    return nomes[index] || `${index + 1}ª Semana`;
  };

  // Contar dias úteis (Seg a Sex) do mês do relatório em uma semana
  const contarDiasUteisSemana = (semana: (DiaCalendario | null)[]) => {
    return semana.filter(dia =>
      dia !== null && dia.isMesAtual && isDiaUtil(dia.dia, dia.mes, dia.ano)
    ).length;
  };

  // Presença mínima obrigatória por semana (apenas dias do mês do relatório):
  // 4 ou 5 dias úteis → 3 obrigatórios (2 opcionais); 3 ou 2 dias úteis → 2 obrigatórios; 1 dia útil → 1 obrigatório
  const getPresencaMinimaObrigatoria = (diasUteis: number): number => {
    if (diasUteis >= 4) return 3;  // 4 ou 5 dias úteis → 3 presenças obrigatórias
    if (diasUteis === 3 || diasUteis === 2) return 2;  // 3 ou 2 dias úteis → 2 obrigatórios
    if (diasUteis === 1) return 1;  // 1 dia útil → 1 obrigatório
    return 0;
  };

  // Verificar se a semana já passou (último dia da linha do calendário já é anterior a hoje)
  const semanaJaPassou = (semana: (DiaCalendario | null)[]): boolean => {
    const hoje = new Date();
    hoje.setHours(0, 0, 0, 0);
    const diasValidos = semana.filter((d): d is DiaCalendario => d !== null);
    if (diasValidos.length === 0) return false;
    let ultimoDia = diasValidos[0];
    for (const d of diasValidos) {
      const dataD = new Date(d.ano, parseInt(d.mes) - 1, d.dia);
      const dataUlt = new Date(ultimoDia.ano, parseInt(ultimoDia.mes) - 1, ultimoDia.dia);
      if (dataD > dataUlt) ultimoDia = d;
    }
    const dataUltimo = new Date(ultimoDia.ano, parseInt(ultimoDia.mes) - 1, ultimoDia.dia);
    dataUltimo.setHours(0, 0, 0, 0);
    return dataUltimo < hoje;
  };

  // Contar impedimentos no período selecionado
  const contarImpedimentosNoPeriodo = (): { total: number; dias: number[] } => {
    const diasComImpedimento: number[] = [];
    const ultimoDiaMes = new Date(formData.ano, parseInt(formData.mes), 0).getDate();

    for (let dia = 1; dia <= ultimoDiaMes; dia++) {
      const impedimento = getImpedimentoDia(dia, formData.mes, formData.ano);
      if (impedimento) {
        diasComImpedimento.push(dia);
      }
    }

    return { total: diasComImpedimento.length, dias: diasComImpedimento };
  };

  // Estilo minimalista (alinhado aos demais componentes de relatório)
  const cardStyle = {
    border: `1px solid ${RELATORIO_CORES.BORDA_CARD}`,
    borderRadius: '8px',
    boxShadow: RELATORIO_CORES.SOMBRA_CARD,
  };
  const headerStyle = {
    backgroundColor: RELATORIO_CORES.CINZA_CLARO,
    color: RELATORIO_CORES.PRIMARIA,
    borderBottom: `1px solid ${RELATORIO_CORES.BORDA_CARD}`,
    borderRadius: '8px 8px 0 0',
  };

  // Renderização das etapas
  const handleFileChangeAcordo = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0] || null;
    if (file) {
      if (file.size > 10 * 1024 * 1024) {
        toast.warning('O arquivo deve ter no máximo 10MB.');
        if (anexoAcordoInputRef.current) {
          anexoAcordoInputRef.current.value = '';
        }
        return;
      }
      setNovoAnexoAcordo(file);
    }
  };

  const stepProps: RelatorioCivelStepProps = {
    podeEditar,
    isViewMode,
    formData,
    setFormData,
    defensoriasOptions,
    getDefensoriaLabel,
    apenasNumeros,
    formatarDataHelper,

    // Step 14
    novoTipoPeca,
    setNovoTipoPeca,
    novoNumeroProcessoDesig,
    setNovoNumeroProcessoDesig,
    novaDefensoriaId,
    setNovaDefensoriaId,
    adicionarDesignacaoEspecialProcesso,
    editandoDesignacaoEspecialProcesso,
    iniciarEdicaoDesignacaoEspecialProcesso,
    salvarEdicaoDesignacaoEspecialProcesso,
    cancelarEdicaoDesignacaoEspecialProcesso,
    removerDesignacaoEspecialProcesso,
    valorEdicaoTipoPeca,
    setValorEdicaoTipoPeca,
    valorEdicaoNumeroProcessoDesig,
    setValorEdicaoNumeroProcessoDesig,
    valorEdicaoDefensoriaId,
    setValorEdicaoDefensoriaId,
    adicionarMultiplasLinhasDesignacaoEspecialProcessos,

    // Step 15
    novaAudienciaDesig,
    setNovaAudienciaDesig,
    novoNumeroProcessoDesigAud,
    setNovoNumeroProcessoDesigAud,
    novaDataDesigAud,
    setNovaDataDesigAud,
    novaDefensoriaIdDesigAud,
    setNovaDefensoriaIdDesigAud,
    adicionarDesignacaoEspecialAudiencia,
    editandoDesignacaoEspecialAudiencia,
    iniciarEdicaoDesignacaoEspecialAudiencia,
    salvarEdicaoDesignacaoEspecialAudiencia,
    cancelarEdicaoDesignacaoEspecialAudiencia,
    removerDesignacaoEspecialAudiencia,
    valorEdicaoAudienciaDesig,
    setValorEdicaoAudienciaDesig,
    valorEdicaoNumeroProcessoDesigAud,
    setValorEdicaoNumeroProcessoDesigAud,
    valorEdicaoDataDesigAud,
    setValorEdicaoDataDesigAud,
    valorEdicaoDefensoriaIdDesigAud,
    setValorEdicaoDefensoriaIdDesigAud,
    adicionarMultiplasLinhasDesignacaoEspecialAudiencias,

    // Step 16
    novoProcessoOutros,
    setNovoProcessoOutros,
    adicionarProcesso,
    adicionarMultiplasLinhas,
    renderTabelaProcessos,

    // Comum
    quantidadeLinhas,
    setQuantidadeLinhas,

    // Step 01
    origemVisualizacao,
    cardStyle,
    headerStyle,
    RELATORIO_CORES,
    justificativaButtonRefs,
    justificativaModalDia,
    justificativaTextoTemp,
    setJustificativaTextoTemp,
    justificativaArquivoTemp,
    fileInputRef,
    handleFileChange,
    salvarJustificativa,
    cancelarJustificativa,
    gerarCalendarioMensal,
    contarImpedimentosNoPeriodo,
    podeCorregedoriaAgirComparecimento,
    diasComparecimentoCorregedoriaPendentes,
    corregedoriaDecisaoDiaLoading,
    aplicarDecisaoCorregedoriaNoDia,
    getMesLabel,
    getNomeSemana,
    contarDiasUteisSemana,
    getPresencaMinimaObrigatoria,
    semanaJaPassou,
    getStatusDia,
    isDiaUtil,
    isDiaFuturo,
    getImpedimentoDia,
    getFeriadosNaData,
    abrirJustificativaModal,
    atualizarStatusDia,
    getTipoPeriodoNome,

    // Step 02
    novoAutor,
    setNovoAutor,
    adicionarAutorNatureza,
    naturezaAcaoOptions,
    novaNatureza,
    setNovaNatureza,
    quantidadeLinhasAutor,
    setQuantidadeLinhasAutor,
    adicionarMultiplasLinhasAutor,
    editandoAutorNatureza,
    confirmandoExclusaoAutor,
    excluirAutorButtonRefs,
    setConfirmandoExclusaoAutor,
    confirmarExclusaoAutor,
    valorEdicaoAutor,
    setValorEdicaoAutor,
    valorEdicaoNatureza,
    setValorEdicaoNatureza,
    iniciarEdicaoAutorNatureza,
    salvarEdicaoAutorNatureza,
    cancelarEdicaoAutorNatureza,

    // Steps 03-06
    novoProcessoContestacao,
    setNovoProcessoContestacao,
    novoProcessoReconvencao,
    setNovoProcessoReconvencao,
    novoProcessoReplica,
    setNovoProcessoReplica,
    novoProcessoManifestacao,
    setNovoProcessoManifestacao,

    // Step 07
    novoProcessoRazoesFinais,
    setNovoProcessoRazoesFinais,

    // Step 08
    TIPOS_AUDIENCIAS,
    novaAudienciaPresencial,
    setNovaAudienciaPresencial,
    novoNumeroProtocolo,
    setNovoNumeroProtocolo,
    novaDataPresencial,
    setNovaDataPresencial,
    adicionarAudienciaPresencial,
    adicionarMultiplasLinhasAudienciasPresenciais,
    editandoAudienciaPresencial,
    valorEdicaoAudienciaPresencial,
    setValorEdicaoAudienciaPresencial,
    valorEdicaoNumeroProtocolo,
    setValorEdicaoNumeroProtocolo,
    valorEdicaoDataPresencial,
    setValorEdicaoDataPresencial,
    salvarEdicaoAudienciaPresencial,
    cancelarEdicaoAudienciaPresencial,
    iniciarEdicaoAudienciaPresencial,
    removerAudienciaPresencial,
    novaAudienciaRemota,
    setNovaAudienciaRemota,
    novoNumeroProcessoRemota,
    setNovoNumeroProcessoRemota,
    novaDataRemota,
    setNovaDataRemota,
    adicionarAudienciaRemota,
    adicionarMultiplasLinhasAudienciasRemotas,
    editandoAudienciaRemota,
    valorEdicaoAudienciaRemota,
    setValorEdicaoAudienciaRemota,
    valorEdicaoNumeroProcessoRemota,
    setValorEdicaoNumeroProcessoRemota,
    valorEdicaoDataRemota,
    setValorEdicaoDataRemota,
    salvarEdicaoAudienciaRemota,
    cancelarEdicaoAudienciaRemota,
    iniciarEdicaoAudienciaRemota,
    removerAudienciaRemota,

    // Step 09
    novoProcessoRecursos,
    setNovoProcessoRecursos,

    // Step 10
    arquivoAtendimentoPresencialInputRef,
    handleFileChangeAtendimentoPresencial,
    novoArquivoAtendimentoPresencial,
    novaObservacaoAtendimentoPresencial,
    setNovaObservacaoAtendimentoPresencial,
    adicionarAtendimentoPresencial,
    adicionarMultiplasLinhasAtendimentosPresenciais,
    editandoAtendimentoPresencial,
    arquivoAtendimentoPresencialEdicaoInputRef,
    handleFileChangeAtendimentoPresencialEdicao,
    valorEdicaoArquivoAtendimentoPresencial,
    valorEdicaoObservacaoAtendimentoPresencial,
    setValorEdicaoObservacaoAtendimentoPresencial,
    salvarEdicaoAtendimentoPresencial,
    cancelarEdicaoAtendimentoPresencial,
    iniciarEdicaoAtendimentoPresencial,
    removerAtendimentoPresencial,
    arquivoAtendimentoRemotoInputRef,
    handleFileChangeAtendimentoRemoto,
    novoArquivoAtendimentoRemoto,
    novaObservacaoAtendimentoRemoto,
    setNovaObservacaoAtendimentoRemoto,
    adicionarAtendimentoRemoto,
    adicionarMultiplasLinhasAtendimentosRemotos,
    editandoAtendimentoRemoto,
    arquivoAtendimentoRemotoEdicaoInputRef,
    handleFileChangeAtendimentoRemotoEdicao,
    valorEdicaoArquivoAtendimentoRemoto,
    valorEdicaoObservacaoAtendimentoRemoto,
    setValorEdicaoObservacaoAtendimentoRemoto,
    salvarEdicaoAtendimentoRemoto,
    cancelarEdicaoAtendimentoRemoto,
    iniciarEdicaoAtendimentoRemoto,
    removerAtendimentoRemoto,

    // Step 11
    apenasLetras,
    novoNomeParteAcordo,
    setNovoNomeParteAcordo,
    anexoAcordoInputRef,
    handleFileChangeAcordo,
    adicionarAcordoExtrajudicial,
    adicionarMultiplasLinhasAcordosExtrajudiciais,
    editandoAcordoExtrajudicial,
    valorEdicaoNomeParteAcordo,
    setValorEdicaoNomeParteAcordo,
    anexoAcordoEdicaoInputRef,
    handleFileChangeAcordoEdicao,
    valorEdicaoAnexoAcordo,
    salvarEdicaoAcordoExtrajudicial,
    cancelarEdicaoAcordoExtrajudicial,
    iniciarEdicaoAcordoExtrajudicial,
    removerAcordoExtrajudicial,

    // Step 12
    novoProcessoSentencaAcordao,
    setNovoProcessoSentencaAcordao,
    adicionarHonorarioSentencaAcordao,
    adicionarMultiplasLinhasHonorariosSentencaAcordao,
    removerHonorarioSentencaAcordao,
    editandoHonorarioSentencaAcordao,
    valorEdicaoProcessoSentencaAcordao,
    setValorEdicaoProcessoSentencaAcordao,
    iniciarEdicaoHonorarioSentencaAcordao,
    salvarEdicaoHonorarioSentencaAcordao,
    cancelarEdicaoHonorarioSentencaAcordao,
    novoProcessoCumprimento,
    setNovoProcessoCumprimento,
    adicionarHonorarioCumprimento,
    adicionarMultiplasLinhasHonorariosCumprimento,
    removerHonorarioCumprimento,
    editandoHonorarioCumprimento,
    valorEdicaoProcessoCumprimento,
    setValorEdicaoProcessoCumprimento,
    iniciarEdicaoHonorarioCumprimento,
    salvarEdicaoHonorarioCumprimento,
    cancelarEdicaoHonorarioCumprimento,

    // Step 13
    novoProcessoRequisitorio,
    setNovoProcessoRequisitorio,
    adicionarOficioRequisitorio,
    adicionarMultiplasLinhasOficiosRequisitorios,
    removerOficioRequisitorio,
    editandoOficioRequisitorio,
    valorEdicaoProcessoRequisitorio,
    setValorEdicaoProcessoRequisitorio,
    iniciarEdicaoOficioRequisitorio,
    salvarEdicaoOficioRequisitorio,
    cancelarEdicaoOficioRequisitorio,
    novoProcessoDemaisOficios,
    setNovoProcessoDemaisOficios,
    adicionarOficioDemais,
    adicionarMultiplasLinhasOficiosDemais,
    removerOficioDemais,
    editandoOficioDemais,
    valorEdicaoProcessoDemaisOficios,
    setValorEdicaoProcessoDemaisOficios,
    iniciarEdicaoOficioDemais,
    salvarEdicaoOficioDemais,
    cancelarEdicaoOficioDemais,

    // Helpers usados por Steps 12/13
    renderTabelaProcessosSimples,
  };

  const renderStep1 = () => <Step01Comparecimento {...stepProps} />;
  const renderStep2 = () => <Step02AutorNatureza {...stepProps} />;
  const renderStep3 = () => <Step03Contestacao {...stepProps} />;
  const renderStep4 = () => <Step04Reconvecao {...stepProps} />;
  const renderStep5 = () => <Step05Replica {...stepProps} />;
  const renderStep6 = () => <Step06Manifestacao {...stepProps} />;
  const renderStep7 = () => <Step07RazoesFinais {...stepProps} />;
  const renderStep8 = () => <Step08Audiencias {...stepProps} />;
  const renderStep9 = () => <Step09Recursos {...stepProps} />;
  const renderStep10 = () => <Step10Atendimentos {...stepProps} />;
  const renderStep11 = () => <Step11AcordosExtrajudiciais {...stepProps} />;
  const renderStep12 = () => <Step12Honorarios {...stepProps} />;
  const renderStep13 = () => <Step13OficiosExpedidos {...stepProps} />;
  const renderStep14 = () => <Step14DesignacaoEspecialProcessos {...stepProps} />;
  const renderStep15 = () => <Step15DesignacaoEspecialAudiencias {...stepProps} />;
  const renderStep16 = () => <Step16OutrosProcedimentos {...stepProps} />;

  const renderCurrentStep = () => {
    switch (currentStep) {
      case 1: return renderStep1();
      case 2: return renderStep2();
      case 3: return renderStep3();
      case 4: return renderStep4();
      case 5: return renderStep5();
      case 6: return renderStep6();
      case 7: return renderStep7();
      case 8: return renderStep8();
      case 9: return renderStep9();
      case 10: return renderStep10();
      case 11: return renderStep11();
      case 12: return renderStep12();
      case 13: return renderStep13();
      case 14: return renderStep14();
      case 15: return renderStep15();
      case 16: return renderStep16();
      default: return renderStep1();
    }
  };

  const exibirAcoesAprovacaoDiretoria = useMemo(() => {
    if (!isViewMode || !relatorioId) return false;
    if (origemVisualizacao === 'corregedoria') return false;
    if (relatorioMetaCorregedoria?.status?.toLowerCase() !== 'enviado') return false;
    if (diretoriaUsuarioId == null || relatorioDiretoriaRegionalId == null) return false;
    if (diretoriaUsuarioId !== relatorioDiretoriaRegionalId) return false;
    const ehAutorReconhecido =
      defensorLogadoIdView != null &&
      defensorData?.id != null &&
      defensorLogadoIdView === defensorData.id;
    if (ehAutorReconhecido) return false;
    return true;
  }, [
    isViewMode,
    relatorioId,
    origemVisualizacao,
    relatorioMetaCorregedoria?.status,
    diretoriaUsuarioId,
    relatorioDiretoriaRegionalId,
    defensorLogadoIdView,
    defensorData?.id,
  ]);

  const relatorioStubDiretoriaModal = useMemo((): RelatorioAtividadeDto | null => {
    if (!relatorioId || !defensorData?.id) return null;
    return {
      id: relatorioId,
      defensorId: defensorData.id,
      defensoriaId: formData.defensoriaId,
      tipo: 'civil',
      status: 'enviado',
      mes: formData.mes,
      ano: formData.ano,
      defensorNome: defensorData.pessoa?.nome || '',
      defensoriaName: formData.defensoriaName || '',
      periodo: `${formData.mes}/${formData.ano}`,
      dataCriacao: '',
    } as RelatorioAtividadeDto;
  }, [relatorioId, defensorData, formData.defensoriaId, formData.defensoriaName, formData.mes, formData.ano]);

  const handleApproveDiretoriaNoEditor = useCallback(async () => {
    if (!relatorioId || diretoriaUsuarioId == null) {
      toast.error('Diretoria não disponível para aprovar.');
      return;
    }
    if (!window.confirm(`Deseja realmente aprovar o relatório de ${defensorData?.pessoa?.nome || 'o defensor'}?`)) {
      return;
    }
    try {
      setAprovingDiretoria(true);
      await AprovarRelatorio(relatorioId, diretoriaUsuarioId);
      toast.success('Relatório aprovado com sucesso!');
      navigate(Links.Relatorios_Aprovacao, { replace: true });
    } catch (error: any) {
      console.error('Erro ao aprovar relatório:', error);
      const mensagem = error?.response?.data?.message || error?.message || 'Erro ao aprovar relatório';
      toast.error(mensagem);
    } finally {
      setAprovingDiretoria(false);
    }
  }, [relatorioId, diretoriaUsuarioId, defensorData?.pessoa?.nome, navigate]);

  const handleConfirmRejectDiretoria = useCallback(
    async (justificativa: string) => {
      if (!relatorioId || diretoriaUsuarioId == null) return;
      try {
        setRejectingDiretoria(true);
        await ReprovarRelatorio(relatorioId, diretoriaUsuarioId, justificativa);
        toast.success('Relatório reprovado com sucesso!');
        setShowRejectModalDiretoria(false);
        navigate(Links.Relatorios_Aprovacao, { replace: true });
      } catch (error: any) {
        console.error('Erro ao reprovar relatório:', error);
        const mensagem = error?.response?.data?.message || error?.message || 'Erro ao reprovar relatório';
        toast.error(mensagem);
      } finally {
        setRejectingDiretoria(false);
      }
    },
    [relatorioId, diretoriaUsuarioId, navigate],
  );

  if (loading) {
    return <Loading />;
  }

  const titularidadeInfo = getTitularidadeLabel(titularidade);
  const progressPercent = (currentStep / WIZARD_STEPS.length) * 100;
  const processoSectionParaImportExcel = STEP_TO_PROCESSO_IMPORT[currentStep];

  return (
    <Fragment>
      <style>{`
        @keyframes triBlink {
          0%, 100% { opacity: 1; transform: scale(1); }
          50% { opacity: 0.25; transform: scale(1.06); }
        }
        .blink-tri {
          animation: triBlink 1s infinite ease-in-out;
        }
      `}</style>
      <Container fluid>
        <div className="mb-4">
          <div className="d-flex align-items-end justify-content-between gap-2">
            <h2 className="mb-0">
              {isViewMode ? 'Visualizar Relatório de Atividades - Cível' : 'Novo Relatório de Atividades - Cível'}
            </h2>
            <div className="d-flex align-items-center gap-2">
              <RelatoriosUserLabel className="mb-1" />
            </div>
          </div>
          <p className="text-muted">
            {isViewMode
              ? 'Visualizando os dados do relatório de atividades cível (modo somente leitura)'
              : 'Preencha os dados do relatório de atividades cível para o período selecionado'
            }
          </p>
        </div>

        {isViewMode && origemVisualizacao !== 'corregedoria' && (
          <div className="alert alert-info mb-4" role="alert">
            <i className="bi bi-info-circle me-2"></i>
            <strong>Modo Visualização:</strong> Você está visualizando este relatório em modo somente leitura.
            Para editar, clique no botão "Editar" na lista de relatórios.
          </div>
        )}

        {/* Card de Informações do Relatório */}
        <Card className="mb-4" style={cardStyle}>
          <Card.Header style={headerStyle}>
            <h5 className="mb-0 fw-bold" style={{ color: RELATORIO_CORES.PRIMARIA }}>Informações do Relatório</h5>
          </Card.Header>
          <Card.Body>
            <Row>
              <Col md={3}>
                <h6 className="text-muted">Defensor</h6>
                <p className="mb-2">
                  <strong>{defensorData?.pessoa?.nome || 'Não informado'}</strong>
                </p>
              </Col>
              <Col md={2}>
                <h6 className="text-muted">Titularidade</h6>
                <p className="mb-2">
                  <Badge bg={titularidadeInfo.variant}>{titularidadeInfo.label}</Badge>
                </p>
              </Col>
              <Col md={2}>
                <h6 className="text-muted">Período</h6>
                <p className="mb-2">
                  <strong>{getMesLabel(formData.mes)}/{formData.ano}</strong>
                </p>
              </Col>
              <Col md={3}>
                <h6 className="text-muted">Defensoria/Vara</h6>
                <p className="mb-2">
                  <strong>{formData.defensoriaName || vara}</strong>
                </p>
              </Col>
              <Col md={2}>
                <h6 className="text-muted">Tipo</h6>
                <p className="mb-2">
                  <Badge bg="primary" style={{ backgroundColor: RELATORIO_CORES.PRIMARIA }}>Cível</Badge>
                </p>
              </Col>
            </Row>

          </Card.Body>
        </Card>

        {/* Wizard Steps Navigation */}
        <Card className="mb-4" style={cardStyle}>
          <Card.Body>
            <ProgressBar
              now={progressPercent}
              label={`${currentStep} de ${WIZARD_STEPS.length}`}
              className="mb-3"
              style={{ height: '25px', backgroundColor: RELATORIO_CORES.TERCIARIA }}
              variant="primary"
            />
            <Nav variant="pills" className="flex-row justify-content-between">
              {WIZARD_STEPS.map((step) => (
                <Nav.Item key={step.id}>
                  <Nav.Link
                    active={currentStep === step.id}
                    onClick={() => handleGoToStep(step.id)}
                    className={`
                      ${currentStep === step.id ? '' : ''}
                      ${currentStep > step.id ? '' : ''}
                      cursor-pointer
                    `}
                    style={{
                      cursor: 'pointer',
                      backgroundColor: currentStep === step.id ? RELATORIO_CORES.PRIMARIA : 'transparent',
                      color: currentStep === step.id ? '#fff' : (currentStep > step.id ? RELATORIO_CORES.PRIMARIA : '#000')
                    }}
                  >
                    <span className="d-none d-lg-inline">{step.id}. {step.title}</span>
                    <span className="d-lg-none">{step.id}. {step.shortTitle}</span>
                    {currentStep > step.id && <i className="bi bi-check-circle-fill ms-2" style={{ color: RELATORIO_CORES.PRIMARIA }}></i>}
                  </Nav.Link>
                </Nav.Item>
              ))}
            </Nav>
          </Card.Body>
        </Card>

        {/* Card do Formulário */}
        <Card className="mb-4" style={cardStyle}>
          <Card.Header style={headerStyle}>
            <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
              <h5 className="mb-0">
                {WIZARD_STEPS[currentStep - 1].title}
              </h5>
              <div className="d-flex align-items-center gap-2 flex-wrap justify-content-end">
                {!isViewMode && (
                  <>
                    <input
                      ref={importNumeroProcessoExcelInputRef}
                      type="file"
                      accept=".xlsx,.xls,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
                      className="d-none"
                      onChange={handleImportNumeroProcessoExcelChange}
                    />
                    <input
                      ref={importAvancadoExcelInputRef}
                      type="file"
                      accept=".xlsx,.xls,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
                      className="d-none"
                      onChange={handleImportAvancadoExcelChange}
                    />
                  </>
                )}
                {currentStep === 2 && !isViewMode && opcoesNaturezaParaImportacao.length > 0 && (
                  <>
                    <input
                      ref={importAutorNaturezaExcelInputRef}
                      type="file"
                      accept=".xlsx,.xls,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
                      className="d-none"
                      onChange={handleImportAutorNaturezaExcelChange}
                    />
                    <Button
                      type="button"
                      variant="outline-primary"
                      size="sm"
                      onClick={() => importAutorNaturezaExcelInputRef.current?.click()}
                      title="Planilha com colunas Autor e Natureza da ação na primeira linha"
                    >
                      <i className="bi bi-file-earmark-arrow-up me-1"></i>
                      Importar Excel
                    </Button>
                  </>
                )}
                {processoSectionParaImportExcel && !isViewMode && (
                  <Button
                    type="button"
                    variant="outline-primary"
                    size="sm"
                    onClick={() =>
                      solicitarImportNumeroProcessoExcel({ tipo: 'processos', section: processoSectionParaImportExcel })
                    }
                    title='Planilha com uma coluna de cabeçalho identificável como "Número do processo" na primeira linha'
                  >
                    <i className="bi bi-file-earmark-arrow-up me-1"></i>
                    Importar Excel
                  </Button>
                )}
                {currentStep === 8 && !isViewMode && (
                  <>
                    <Button
                      type="button"
                      variant="outline-primary"
                      size="sm"
                      onClick={() => solicitarImportAvancadoExcel({ tipo: 'audiencias-presencial' })}
                      title="Colunas: tipo de audiência (lista do sistema), número/protocolo e data (AAAA-MM-DD ou DD/MM/AAAA)"
                    >
                      <i className="bi bi-file-earmark-arrow-up me-1"></i>
                      Importar (Presenciais)
                    </Button>
                    <Button
                      type="button"
                      variant="outline-primary"
                      size="sm"
                      onClick={() => solicitarImportAvancadoExcel({ tipo: 'audiencias-remota' })}
                      title="Colunas: tipo de audiência, número do processo e data"
                    >
                      <i className="bi bi-file-earmark-arrow-up me-1"></i>
                      Importar (Remotas)
                    </Button>
                  </>
                )}
                {currentStep === 14 && !isViewMode && (
                  <Button
                    type="button"
                    variant="outline-primary"
                    size="sm"
                    onClick={() => solicitarImportAvancadoExcel({ tipo: 'designacao-processo' })}
                    title="Colunas: tipo de peça, número do processo e defensoria/vara (texto ou código)"
                  >
                    <i className="bi bi-file-earmark-arrow-up me-1"></i>
                    Importar Excel
                  </Button>
                )}
                {currentStep === 15 && !isViewMode && (
                  <Button
                    type="button"
                    variant="outline-primary"
                    size="sm"
                    onClick={() => solicitarImportAvancadoExcel({ tipo: 'designacao-audiencia' })}
                    title="Colunas: audiência/tipo, número do processo, data e defensoria/vara"
                  >
                    <i className="bi bi-file-earmark-arrow-up me-1"></i>
                    Importar Excel
                  </Button>
                )}
                {currentStep === 12 && !isViewMode && (
                  <>
                    <Button
                      type="button"
                      variant="outline-primary"
                      size="sm"
                      onClick={() => solicitarImportNumeroProcessoExcel({ tipo: 'honorarios-sentenca' })}
                      title='Planilha com uma coluna de cabeçalho identificável como "Número do processo" na primeira linha'
                    >
                      <i className="bi bi-file-earmark-arrow-up me-1"></i>
                      Importar (Sentença/Acórdão)
                    </Button>
                    <Button
                      type="button"
                      variant="outline-primary"
                      size="sm"
                      onClick={() => solicitarImportNumeroProcessoExcel({ tipo: 'honorarios-cumprimento' })}
                      title='Planilha com uma coluna de cabeçalho identificável como "Número do processo" na primeira linha'
                    >
                      <i className="bi bi-file-earmark-arrow-up me-1"></i>
                      Importar (Cumprimento)
                    </Button>
                  </>
                )}
                {currentStep === 13 && !isViewMode && (
                  <>
                    <Button
                      type="button"
                      variant="outline-primary"
                      size="sm"
                      onClick={() => solicitarImportNumeroProcessoExcel({ tipo: 'oficios-requisitorios' })}
                      title='Planilha com uma coluna de cabeçalho identificável como "Número do processo" na primeira linha'
                    >
                      <i className="bi bi-file-earmark-arrow-up me-1"></i>
                      Importar (Requisitórios)
                    </Button>
                    <Button
                      type="button"
                      variant="outline-primary"
                      size="sm"
                      onClick={() => solicitarImportNumeroProcessoExcel({ tipo: 'oficios-demais' })}
                      title='Planilha com uma coluna de cabeçalho identificável como "Número do processo" na primeira linha'
                    >
                      <i className="bi bi-file-earmark-arrow-up me-1"></i>
                      Importar (Demais ofícios)
                    </Button>
                  </>
                )}
                <Badge bg="secondary">
                  {currentStep} / {WIZARD_STEPS.length}
                </Badge>
              </div>
            </div>
          </Card.Header>
          <Card.Body>
            <Form>
              <fieldset disabled={isViewMode} style={{ margin: 0, padding: 0, border: 0 }}>
                {isViewMode && (
                  <style>
                    {`
                      .relatorio-readonly .btn,
                      .relatorio-readonly input,
                      .relatorio-readonly select,
                      .relatorio-readonly textarea {
                        display: none !important;
                      }
                    `}
                  </style>
                )}
                <div className={isViewMode ? 'relatorio-readonly' : undefined}>{renderCurrentStep()}</div>
              </fieldset>
            </Form>
          </Card.Body>
        </Card>

        {/* Navegação inferior: Anterior / ações de diretoria (quando aplicável) / Próximo */}
        <Card className="mb-4" style={cardStyle}>
          <Card.Body className="d-flex flex-wrap align-items-center justify-content-between gap-3">
            <div className="d-flex align-items-center gap-2">
              {currentStep > 1 && (
                <button
                  type="button"
                  className="btn btn-outline-primary"
                  onClick={async () => {
                    if (saving) return;
                    if (!isViewMode) await autoSave();
                    setCurrentStep((prev) => Math.max(1, prev - 1));
                  }}
                  style={{ borderColor: RELATORIO_CORES.PRIMARIA, color: RELATORIO_CORES.PRIMARIA }}
                >
                  <i className="bi bi-arrow-left me-2"></i>
                  Anterior
                </button>
              )}
            </div>
            {exibirAcoesAprovacaoDiretoria && (
              <div className="d-flex flex-wrap align-items-center justify-content-center gap-2 flex-grow-1">
                <Button
                  variant="outline-success"
                  size="sm"
                  onClick={handleApproveDiretoriaNoEditor}
                  disabled={aprovingDiretoria || rejectingDiretoria}
                >
                  {aprovingDiretoria ? 'Aprovando...' : 'Aprovar'}
                </Button>
                <Button
                  variant="outline-warning"
                  size="sm"
                  className="text-dark"
                  onClick={() => setShowRejectModalDiretoria(true)}
                  disabled={aprovingDiretoria || rejectingDiretoria}
                >
                  Devolver ao Defensor
                </Button>
              </div>
            )}
            <div className="d-flex align-items-center gap-2 ms-auto">
              {currentStep < WIZARD_STEPS.length && (
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => {
                    if (saving) return;
                    handleNextStepRef.current();
                  }}
                  style={{ backgroundColor: RELATORIO_CORES.PRIMARIA, borderColor: RELATORIO_CORES.PRIMARIA }}
                >
                  Próximo
                  <i className="bi bi-arrow-right ms-2"></i>
                </button>
              )}
            </div>
          </Card.Body>
        </Card>

        {/* Modal: Resumo do Relatório */}
        <Modal show={showResumoModal} onHide={() => setShowResumoModal(false)} size="lg" centered>
          <Modal.Header closeButton>
            <Modal.Title>Resumo do Relatório</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="border rounded">
              <Table bordered size="sm" className="mb-0">
                <thead className="table-light">
                  <tr>
                    <th style={{ width: '60%' }}>Seção / Subseção</th>
                    <th style={{ width: '40%', textAlign: 'center' }}>Quantidade</th>
                  </tr>
                </thead>
                <tbody>
                  <tr><td>2. Autor e Natureza da Ação</td><td className="text-center">{formData.autorNatureza.itens.length}</td></tr>
                  <tr><td>3. Contestação</td><td className="text-center">{formData.contestacao.processos.length}</td></tr>
                  <tr><td>4. Reconvenção</td><td className="text-center">{formData.reconvencao.processos.length}</td></tr>
                  <tr><td>5. Réplica</td><td className="text-center">{formData.replica.processos.length}</td></tr>
                  <tr><td>6. Manifestação nos Autos</td><td className="text-center">{formData.manifestacao.processos.length}</td></tr>
                  <tr><td>7. Razões Finais</td><td className="text-center">{formData.razoesFinais.processos.length}</td></tr>
                  <tr><td>8. Audiências</td><td className="text-center">—</td></tr>
                  <tr><td className="ps-4"><small>Audiências Presenciais</small></td><td className="text-center">{formData.audiencias.presenciais.length}</td></tr>
                  <tr><td className="ps-4"><small>Audiências Remotas</small></td><td className="text-center">{formData.audiencias.remotas.length}</td></tr>
                  <tr><td>9. Recursos</td><td className="text-center">{formData.recursos.processos.length}</td></tr>
                  <tr><td>10. Atendimentos</td><td className="text-center">—</td></tr>
                  <tr><td className="ps-4"><small>Atendimentos Presenciais</small></td><td className="text-center">{formData.atendimento.presenciais.length}</td></tr>
                  <tr><td className="ps-4"><small>Atendimentos Remotos</small></td><td className="text-center">{formData.atendimento.remotas.length}</td></tr>
                  <tr><td>11. Acordos Extrajudiciais</td><td className="text-center">{formData.acordosExtrajudiciais.itens.length}</td></tr>
                  <tr><td>12. Honorários</td><td className="text-center">—</td></tr>
                  <tr><td className="ps-4"><small>Sentença/Acórdão</small></td><td className="text-center">{formData.honorarios.sentencaAcordao.length}</td></tr>
                  <tr><td className="ps-4"><small>Cumprimento</small></td><td className="text-center">{formData.honorarios.cumprimento.length}</td></tr>
                  <tr><td>13. Ofícios Expedidos</td><td className="text-center">—</td></tr>
                  <tr><td className="ps-4"><small>Requisitórios</small></td><td className="text-center">{formData.oficiosExpedidos.requisitorios.length}</td></tr>
                  <tr><td className="ps-4"><small>Demais</small></td><td className="text-center">{formData.oficiosExpedidos.demais.length}</td></tr>
                  <tr><td>14. Designação Especial (Processos)</td><td className="text-center">{formData.designacaoEspecialProcessos.itens.length}</td></tr>
                  <tr><td>15. Designação Especial (Audiências)</td><td className="text-center">{formData.designacaoEspecialAudiencias.itens.length}</td></tr>
                  <tr><td>16. Outros Procedimentos</td><td className="text-center">{formData.outrosProcedimentos.processos.length}</td></tr>
                  <tr className="table-light">
                    <td className="fw-bold">Total de itens</td>
                    <td className="text-center fw-bold">
                      {
                        formData.autorNatureza.itens.length +
                        formData.contestacao.processos.length +
                        formData.reconvencao.processos.length +
                        formData.replica.processos.length +
                        formData.manifestacao.processos.length +
                        formData.razoesFinais.processos.length +
                        formData.audiencias.presenciais.length +
                        formData.audiencias.remotas.length +
                        formData.recursos.processos.length +
                        formData.atendimento.presenciais.length +
                        formData.atendimento.remotas.length +
                        formData.acordosExtrajudiciais.itens.length +
                        formData.honorarios.sentencaAcordao.length +
                        formData.honorarios.cumprimento.length +
                        formData.oficiosExpedidos.requisitorios.length +
                        formData.oficiosExpedidos.demais.length +
                        formData.designacaoEspecialProcessos.itens.length +
                        formData.designacaoEspecialAudiencias.itens.length +
                        formData.outrosProcedimentos.processos.length
                      }
                    </td>
                  </tr>
                </tbody>
              </Table>
            </div>
          </Modal.Body>
        </Modal>

        {/* Modal: Confirmar envio */}
        <Modal
          show={showEnviarModal}
          onHide={() => (saving ? null : setShowEnviarModal(false))}
          centered
          backdrop={saving ? 'static' : true}
          keyboard={!saving}
        >
          <Modal.Header closeButton={!saving}>
            <Modal.Title>Confirmar envio do relatório</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p className="mb-2">
              Tem certeza que deseja enviar este relatório?
            </p>
            <p className="mb-0 text-muted">
              Após o envio, <strong>não será possível editar</strong> o relatório.
            </p>
          </Modal.Body>
          <Modal.Footer>
            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={() => setShowEnviarModal(false)}
              disabled={saving}
            >
              Cancelar
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={async () => {
                if (saving) return;
                if (!mesRelatorioTerminado) {
                  toast.warning('O relatório ainda não pode ser enviado devido ao prazo.');
                  setShowEnviarModal(false);
                  return;
                }

                // Envia mantendo na tela
                await handleSaveRef.current(false, true);

                // Reabrir como somente leitura (atualiza URL e estado local)
                const params = new URLSearchParams(searchParams.toString());
                params.set('view', 'true');
                navigate(`${Links.Relatorios_Criar}?${params.toString()}`, { replace: true });
                setIsViewMode(true);
                setShowEnviarModal(false);
              }}
              disabled={saving}
              style={{ backgroundColor: RELATORIO_CORES.PRIMARIA, borderColor: RELATORIO_CORES.PRIMARIA }}
            >
              {metaReenvioCorregedoria ? 'Enviar à Corregedoria' : 'Enviar Relatório'}
            </button>
          </Modal.Footer>
        </Modal>

        <ModalImportarExcelRelatorioCivel
          variant="autor-natureza"
          show={showImportAutorNaturezaModal}
          linhas={importAutorNaturezaLinhas}
          onHide={cancelarImportAutorNaturezaModal}
          onConfirmar={confirmarImportAutorNaturezaComPreview}
        />

        <ModalImportarExcelRelatorioCivel
          variant="numero-processo"
          show={showImportNumeroProcessoModal}
          tituloSecao={importNumeroProcessoAlvo ? tituloModalImportNumero(importNumeroProcessoAlvo) : 'Número do processo'}
          linhas={importNumeroProcessoLinhas}
          onHide={cancelarImportNumeroProcessoModal}
          onConfirmar={confirmarImportNumeroProcessoComPreview}
        />

        {importAvancado.open && importAvancado.variant === 'audiencias-presencial' && (
          <ModalImportarExcelRelatorioCivel
            variant="audiencias-presencial"
            show
            linhas={importAvancado.linhas}
            onHide={cancelarImportAvancadoModal}
            onConfirmar={confirmarImportAvancadoComPreview}
          />
        )}
        {importAvancado.open && importAvancado.variant === 'audiencias-remota' && (
          <ModalImportarExcelRelatorioCivel
            variant="audiencias-remota"
            show
            linhas={importAvancado.linhas}
            onHide={cancelarImportAvancadoModal}
            onConfirmar={confirmarImportAvancadoComPreview}
          />
        )}
        {importAvancado.open && importAvancado.variant === 'designacao-processo' && (
          <ModalImportarExcelRelatorioCivel
            variant="designacao-processo"
            show
            linhas={importAvancado.linhas}
            onHide={cancelarImportAvancadoModal}
            onConfirmar={confirmarImportAvancadoComPreview}
          />
        )}
        {importAvancado.open && importAvancado.variant === 'designacao-audiencia' && (
          <ModalImportarExcelRelatorioCivel
            variant="designacao-audiencia"
            show
            linhas={importAvancado.linhas}
            onHide={cancelarImportAvancadoModal}
            onConfirmar={confirmarImportAvancadoComPreview}
          />
        )}

        <ModalReprovacao
          show={showRejectModalDiretoria}
          relatorio={relatorioStubDiretoriaModal}
          onHide={() => setShowRejectModalDiretoria(false)}
          onConfirm={handleConfirmRejectDiretoria}
          loading={rejectingDiretoria}
          contexto="diretoria"
        />
      </Container>
    </Fragment>
  );
}
